<template>
  <div id="paginaSpettacoli">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Grid View: GridElencoSpettacoli -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Elenco Spettacoli</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropStagioni"
                  ref="dropStagioni"
                  :query="queryStagioni"
                  :dataSource="stagioniData"
                  :index="stagioniIndex"
                  :fields="stagioniFields"
                  :change="onStagioneChange"
                  v-model="stagioneCorrente"
                  placeholder="Seleziona un Anno"
                ></ejs-dropdownlist>
              </b-col>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert
                  :show="alertADismissCountDown"
                  dismissible
                  variant="warning"
                  @dismissed="alertADismissCountDown = 0"
                  @dismiss-count-down="alertACountDownChanged"
                >
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-alert
                    variant="warning"
                    :max="alertADismissSecs"
                    :value="alertADismissCountDown"
                    height="4px"
                  />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1">
                <ejs-grid
                  id="gridA"
                  ref="gridA"
                  :dataSource="spettacoliFullData"
                  :allowSorting="true"
                  :sortSettings="gridA.sortOptions"
                  :toolbarClick="gridAClickHandler"
                  :toolbar="gridA.toolbarOptions"
                  :height="gridA.height"
                  :allowFiltering="true"
                  :filterSettings="gridA.filterOptions"
                  :editSettings="gridA.editOptions"
                  :actionBegin="gridAactionBegin"
                  :actionComplete="gridAactionComplete">
                  <e-columns>
                    <e-column field="id" headerText="ID" :isPrimaryKey="true" width="60"></e-column>
                    <e-column field="titolo" headerText="Titolo" width="150"></e-column>
                    <e-column field="stagione" headerText="Anno" width="60"
                      foreignKeyField="val" foreignKeyValue="label"
                      :dataSource="this.spettacoliStagioneList"></e-column>
                    <e-column field="dataInizio" headerText="Data Inizio" width="100"
                        :format="settings.formatoData" type="date" ></e-column>
                    <e-column field="ministero" headerText="Ministero" width="100"
                      foreignKeyField="val" foreignKeyValue="label"
                      :dataSource="this.booleanList"></e-column>
                    <e-column
                      field="tipologia" headerText="Tipologia" width="100"
                      foreignKeyField="val" foreignKeyValue="label"
                      :dataSource="this.spettacoliTipologiaList"></e-column>
                    <e-column
                      field="stato" headerText="Stato" width="100"
                      foreignKeyField="val" foreignKeyValue="label"
                      :dataSource="this.spettacoliStatoList"></e-column>
                  </e-columns>
                </ejs-grid>
              </b-col>
              <b-col xl="4" md="4" class="pt-1">
                <ejs-button id="downloadAnnoButton" cssClass="e-flat" @click.native="downloadXls()">Scarica Excel Spettacoli Anno</ejs-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA: dialogDettaglioSpettacolo ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogA"
      ref="dialogA"
      :header="dialogA.header"
      :buttons="dialogA.buttons"
      :visible="dialogA.visible"
      :showCloseIcon="dialogA.showCloseIcon"
      :close="dialogAClose"
      :open="dialogAOpen"
      :zIndex="dialogA.zIndex"
      :animationSettings="dialogA.animationSettings"
      :isModal="dialogA.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA" v-model="dialogA.tabAdialogAIndex">
        <b-tab title="Dati Spettacolo" @click="tabClicked('dialogATab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input: dati spettacolo -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dati Spettacolo</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo testo: spettacoliActiveData.id  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="id" class="h5">Id</label>
                      <ejs-textbox
                        id="id"
                        v-model="spettacoliActiveData.id"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="id"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.titolo  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="titolo" class="h5">Titolo</label>
                      <ejs-textbox
                        id="titolo"
                        v-model="spettacoliActiveData.titolo"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Titolo"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.tipologia  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tipologia" class="h5">Tipologia</label>
                      <ejs-dropdownlist
                        id="tipologia"
                        v-model="spettacoliActiveData.tipologia"
                        :dataSource="spettacoliTipologiaList"
                        :fields="spettacoliTipologiaFields"
                        :allowFiltering="true"
                        placeholder="Tipologia"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.stagione  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="stagione" class="h5">Anno</label>
                      <ejs-dropdownlist
                        id="stagione"
                        v-model="spettacoliActiveData.stagione"
                        :dataSource="spettacoliStagioneList"
                        :fields="spettacoliStagioneFields"
                        :allowFiltering="true"
                        placeholder="Anno"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.rassegna  -->
                    <!-- <b-col xl="12" md="12" class="mb-2">
                      <label for="rassegna" class="h5">Rassegna</label>
                      <ejs-dropdownlist
                        id="rassegna"
                        v-model="spettacoliActiveData.rassegna"
                        :dataSource="spettacoliRassegnaList"
                        :fields="spettacoliRassegnaFields"
                        :allowFiltering="true"
                        placeholder="Rassegna"
                      />
                    </b-col> -->

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.organizzatore  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="organizzatore" class="h5">Organizzatore</label>
                      <ejs-dropdownlist
                        id="organizzatore"
                        v-model="spettacoliActiveData.organizzatore"
                        :dataSource="spettacoliOrganizzatoreList"
                        :fields="spettacoliOrganizzatoreFields"
                        :allowFiltering="true"
                        placeholder="Organizzatore"
                      />
                    </b-col>

                    <!-- Input di tipo data: spettacoliActiveData.dataInizio -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dataInizio" class="h5">Data Inizio</label>
                      <ejs-datepicker
                        id="dataInizio"
                        v-model="spettacoliActiveData.dataInizio"
                        :format="settings.formatoDatepicker"
                        placeholder="Data Inizio"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <!-- Input di tipo data: spettacoliActiveData.dataFine -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dataFine" class="h5">Data Fine</label>
                      <ejs-datepicker
                        id="dataFine"
                        v-model="spettacoliActiveData.dataFine"
                        :format="settings.formatoDatepicker"
                        placeholder="Data Fine"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.descrizione  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="descrizione" class="h5">Descrizione</label>
                      <ejs-textbox
                        id="descrizione"
                        v-model="spettacoliActiveData.descrizione"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Descrizione"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="2"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="breveDescrizione" class="h5"
                        >Breve Descrizione</label
                      >
                      <ejs-textbox
                        id="breveDescrizione"
                        v-model="spettacoliActiveData.breve_descrizione"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Breve Descrizione"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="2"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.durataVVF Da nascondere dopo utilizzo pagine VVF (presente in recite) -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="durataVVF" class="h5"
                        >Durata Presunta per VVF</label
                      >
                      <ejs-numerictextbox
                        id="durataVVF"
                        v-model="spettacoliActiveData.durataVVF"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Durata VVF"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo valuta: spettacoliActiveData.proventi -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="proventi" class="h5"
                        >Proventi</label
                      >
                      <ejs-numerictextbox
                        id="proventi"
                        v-model="spettacoliActiveData.proventi"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###.##"
                        placeholder="Proventi"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>


                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.stato  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="stato" class="h5">Stato</label>
                      <ejs-dropdownlist
                        id="stato"
                        v-model="spettacoliActiveData.stato"
                        :dataSource="spettacoliStatoList"
                        :fields="spettacoliStatoFields"
                        :allowFiltering="true"
                        placeholder="Stato"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.centroDiCosto  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="centroDiCosto" class="h5"
                        >Centro di Costo</label
                      >
                      <ejs-textbox
                        id="centroDiCosto"
                        v-model="spettacoliActiveData.centroDiCosto"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Centro di Costo"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.coproduzione -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="coproduzione" class="h5 mr-1">Coproduzione</label>
                        <ejs-checkbox
                          id="coproduzione"
                          v-model="spettacoliActiveData.coproduzione"
                          :checked="spettacoliActiveData.coproduzione"
                          name="coproduzione"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.ospitalita -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="ospitalita" class="h5 mr-1"
                          >Ospitalità</label
                        >
                        <ejs-checkbox
                          id="ospitalita"
                          v-model="spettacoliActiveData.ospitalita"
                          :checked="spettacoliActiveData.ospitalita"
                          name="ospitalita"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.ministero -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="ministero" class="h5 mr-1">Ministero</label>
                        <ejs-checkbox
                          id="ministero"
                          v-model="spettacoliActiveData.ministero"
                          :checked="spettacoliActiveData.ministero"
                          name="ministero"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.regione -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="regione" class="h5 mr-1">Regione</label>
                        <ejs-checkbox
                          id="regione"
                          v-model="spettacoliActiveData.regione"
                          :checked="spettacoliActiveData.regione"
                          name="regione"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.comune -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="comune" class="h5 mr-1">Comune</label>
                        <ejs-checkbox
                          id="comune"
                          v-model="spettacoliActiveData.comune"
                          :checked="spettacoliActiveData.comune"
                          name="comune"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.paragrafoQualitaArtistica  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="paragrafoQualitaArtistica" class="h5">Paragrafo Qualità Artistica</label>
                      <ejs-textbox
                        id="paragrafoQualitaArtistica"
                        v-model="spettacoliActiveData.paragrafoQualitaArtistica"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="paragrafoQualitaArtistica"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="5"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.paragrafoInnovazione  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="paragrafoInnovazione" class="h5">Paragrafo Innovazione</label>
                      <ejs-textbox
                        id="paragrafoInnovazione"
                        v-model="spettacoliActiveData.paragrafoInnovazione"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="paragrafoInnovazione"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="5"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.paragrafoAttFormative  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="paragrafoAttFormative" class="h5">Paragrafo Attività Formative</label>
                      <ejs-textbox
                        id="paragrafoAttFormative"
                        v-model="spettacoliActiveData.paragrafoAttFormative"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="paragrafoAttFormative"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="5"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.paragrafoMultidisciplinarieta  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="paragrafoMultidisciplinarieta" class="h5">Paragrafo Multidisciplinarietà</label>
                      <ejs-textbox
                        id="paragrafoMultidisciplinarieta"
                        v-model="spettacoliActiveData.paragrafoMultidisciplinarieta"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="paragrafoMultidisciplinarieta"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="5"
                      />
                    </b-col>

                    <!-- Input di tipo testo valuta: spettacoliActiveData.costoPrevisto  -->
                    <b-col xl="12" md="12" class="mb-2">
                          <label for="costoPrevisto" class="h5">Costo Totale Previsto</label>
                          <ejs-numerictextbox id="costoPrevisto" v-model="spettacoliActiveData.costoPrevisto"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costo Totale Previsto"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <!-- Input di tipo testo valuta: spettacoliActiveData.costoEffettivo  -->
                    <b-col xl="12" md="12" class="mb-2">
                          <label for="costoEffettivo" class="h5">Costo Totale Effettivo</label>
                          <ejs-numerictextbox id="costoEffettivo" v-model="spettacoliActiveData.costoEffettivo"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costo Totale Effettivo"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <!-- Input di tipo testo valuta: spettacoliActiveData.costoSIAEPrevisto  -->
                    <b-col xl="12" md="12" class="mb-2">
                          <label for="costoSIAEPrevisto" class="h5">Costo SIAE Previsto</label>
                          <ejs-numerictextbox id="costoSIAEPrevisto" v-model="spettacoliActiveData.costoSIAEPrevisto"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costo SIAE Previsto"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <!-- Input di tipo testo valuta: spettacoliActiveData.costoSIAEEffettivo  -->
                    <b-col xl="12" md="12" class="mb-2">
                          <label for="costoSIAEEffettivo" class="h5">Costo SIAE Effettivo</label>
                          <ejs-numerictextbox id="costoSIAEEffettivo" v-model="spettacoliActiveData.costoSIAEEffettivo"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costo SIAE Effettivo"
                                              showSpinButton="false" showClearButton="true" />
                    </b-col>


                    <!-- Input di tipo testo valuta: spettacoliActiveData.costoVVFPrevisto  -->
                    <b-col xl="12" md="12" class="mb-2">
                          <label for="costoVVFPrevisto" class="h5">Costo VVF Previsto</label>
                          <ejs-numerictextbox id="costoVVFPrevisto" v-model="spettacoliActiveData.costoVVFPrevisto"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costo VVF Previsto"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <!-- Input di tipo testo valuta: spettacoliActiveData.costoVVFEffettivo  -->
                    <b-col xl="12" md="12" class="mb-2">
                          <label for="costoVVFEffettivo" class="h5">Costo VVF Effettivo</label>
                          <ejs-numerictextbox id="costoVVFEffettivo" v-model="spettacoliActiveData.costoVVFEffettivo"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costo VVF Effettivo"
                                              showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo testo valuta: spettacoliActiveData.incassoPrevisto  -->
                    <b-col xl="12" md="12" class="mb-2">
                          <label for="incassoPrevisto" class="h5">Incasso Totale Previsto</label>
                          <ejs-numerictextbox id="incassoPrevisto" v-model="spettacoliActiveData.incassoPrevisto"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Incasso Totale Previsto"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <!-- Input di tipo testo valuta: spettacoliActiveData.incassoEffettivo  Diventerà Readonly quando leggeremo correttamente gli incassi spettacolo -->
                    <b-col xl="12" md="12" class="mb-2">
                          <label for="incassoEffettivo" class="h5">Incasso Totale Effettivo</label>
                          <ejs-numerictextbox id="incassoEffettivo" v-model="spettacoliActiveData.incassoEffettivo"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Incasso Totale Effettivo"
                                              showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo testo valuta: spettacoliActiveData.contributoCoproduzione -->
                    <b-col xl="12" md="12" class="mb-2">
                          <label for="contributoCoproduzione" class="h5">Contributo Coproduzione</label>
                          <ejs-numerictextbox id="contributoCoproduzione" v-model="spettacoliActiveData.contributoCoproduzione"
                                              floatLabelType="Never" cssClass="" format="€ ####.##" placeholder="Contributo Coproduzione"
                                              showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                          <label for="costoCoproduzione" class="h5">Costo Coproduzione</label>
                          <ejs-numerictextbox id="costoCoproduzione" v-model="spettacoliActiveData.costoCoproduzione"
                                              floatLabelType="Never" cssClass="" format="€ ####.##" placeholder="Costo Coproduzione"
                                              showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                          <label for="cachetCompagnieOspiti" class="h5">Cachet Compagnie Ospiti</label>
                          <ejs-numerictextbox id="cachetCompagnieOspiti" v-model="spettacoliActiveData.cachetCompagnieOspiti"
                                              floatLabelType="Never" cssClass="" format="€ ####.##"  placeholder="Cachet Compagnie Ospiti"
                                              showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo testo valuta: spettacoliActiveData.costoConsuntivoContabile -->
                    <b-col xl="12" md="12" class="mb-2">
                          <label for="costoConsuntivoContabile" class="h5">Costo Consuntivo Contabile</label>
                          <ejs-numerictextbox id="costoConsuntivoContabile" v-model="spettacoliActiveData.costoConsuntivoContabile"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costo Consuntivo Contabile"
                                              showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo testo valuta: spettacoliActiveData.costoConsuntivoSmartControl -->
                    <b-col xl="12" md="12" class="mb-2">
                          <label for="costoConsuntivoSmartControl" class="h5">Costo Consuntivo Smart Control</label>
                          <ejs-numerictextbox id="costoConsuntivoSmartControl" v-model="spettacoliActiveData.costoConsuntivoSmartControl"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costo Consuntivo Smart Control"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                          <label for="costiPubblicitariPrev" class="h5">Costi pubblicitari preventivo</label>
                          <ejs-numerictextbox id="costiPubblicitariPrev" v-model="spettacoliActiveData.costiPubblicitariPrev"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costi Pubblicitari Preventivo"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                          <label for="costiPubblicitariCons" class="h5">Costi Pubblicitari consuntivo</label>
                          <ejs-numerictextbox id="costiPubblicitariCons" v-model="spettacoliActiveData.costiPubblicitariCons"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costi pubblicitari consuntivo"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                          <label for="costiDipInterniPrev" class="h5">Costi dipendenti interni preventivo</label>
                          <ejs-numerictextbox id="costiDipInterniPrev" v-model="spettacoliActiveData.costiDipInterniPrev"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costi Dipendenti interni preventivo"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                          <label for="costiDipInterniCons" class="h5">Costi dipendenti Interni consuntivo</label>
                          <ejs-numerictextbox id="costiDipInterniCons" v-model="spettacoliActiveData.costiDipInterniCons"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costi dipendenti interni consuntivo"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                          <label for="costiDirArtisticaPrev" class="h5">Costi direzione artistica preventivo</label>
                          <ejs-numerictextbox id="costiDirArtisticaPrev" v-model="spettacoliActiveData.costiDirArtisticaPrev"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costi direzione artistica preventivo"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                          <label for="costiDirArtisticaCons" class="h5">Costi direzione artistica consuntivo</label>
                          <ejs-numerictextbox id="costiDirArtisticaCons" v-model="spettacoliActiveData.costiDirArtisticaCons"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costi direzione artistica consuntivo"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                          <label for="costiMaschereGipPrev" class="h5">Costi Maschere preventivo</label>
                          <ejs-numerictextbox id="costiMaschereGipPrev" v-model="spettacoliActiveData.costiMaschereGipPrev"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costi maschere preventivo"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                          <label for="costiMaschereGipCons" class="h5">Costi Maschere consuntivo</label>
                          <ejs-numerictextbox id="costiMaschereGipCons" v-model="spettacoliActiveData.costiMaschereGipCons"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Costi maschere consuntivo"
                                              showSpinButton="false" showClearButton="true" :readonly="false" />
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.bilancioProduzioneSMValidato -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="bilancioProduzioneSMValidato" class="h5 mr-1">Bilancio Produzione Smart Control Validato</label>
                        <ejs-checkbox
                          id="bilancioProduzioneSMValidato"
                          v-model="spettacoliActiveData.bilancioProduzioneSMValidato"
                          :checked="spettacoliActiveData.bilancioProduzioneSMValidato"
                          name="bilancioProduzioneSMValidato"
                        />
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: immagineLocandina -->
            <b-col xl="6" md="12" v-show="nonMostrare">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Locandina</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo immagine con azioni: spettacoliActiveData.immagineLocandina -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="immagineLocandina" class="h5"
                        >Immagine Locandina</label
                      >
                      <b-row>
                        <b-col xl="12" md="12" class="pt-1">
                          <b-img
                            :src="spettacoliActiveData.immagineLocandina"
                            fluid
                            alt="Responsive image"
                          />
                        </b-col>
                        <b-col xl="12" md="12" class="text-right mt-1">
                          <ejs-button
                            id="cambiaLocandinaButton"
                            cssClass="e-flat"
                            @click.native="dialogBOpenButtonClick()"
                            >Cambia
                          </ejs-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <b-tab
          title="Documenti Allegati"
          v-if="nonMostrare"
          @click="tabClicked('dialogATab02')"
        >
          <b-row class="match-height">
            <!-- Card Grid View: gridDocumentiAllegati -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Elenco Documenti Allegati</b-card-title>
                    <b-card-text class="mb-0"> </b-card-text>
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Timer Alert -->
                    <b-col xl="6" md="12">
                      <b-alert
                        :show="alertADismissCountDown"
                        dismissible
                        variant="warning"
                        @dismissed="alertADismissCountDown = 0"
                        @dismiss-count-down="alertACountDownChanged"
                      >
                        <p>Occorre selezionare una riga della tabella</p>
                        <b-progress
                          variant="warning"
                          :max="alertADismissSecs"
                          :value="alertADismissCountDown"
                          height="4px"
                        />
                      </b-alert>
                    </b-col>

                    <b-col xl="12" md="12" class="pt-1">
                      <ejs-grid
                        id="gridB"
                        ref="gridB"
                        :dataSource="docSpettacoloFullData"
                        :allowSorting="true"
                        :toolbarClick="gridBClickHandler"
                        :toolbar="gridB.toolbarOptions"
                        :height="gridB.height"
                        :allowFiltering="true"
                        :filterSettings="gridB.filterOptions"
                        :editSettings="gridB.editOptions"
                        :actionBegin="gridBactionBegin"
                        :actionComplete="gridBactionComplete"
                      >
                        <e-columns>
                          <e-column
                            field="id"
                            headerText="ID"
                            :isPrimaryKey="true"
                            width="60"
                          ></e-column>
                          <e-column
                            field="tipologia"
                            headerText="Tipologia"
                            width="200"
                          ></e-column>
                          <e-column
                            field="scadenza"
                            headerText="Scadenza"
                            width="200"
                            :format="settings.formatoData"
                            type="date"
                          ></e-column>
                          <e-column
                            field="note"
                            headerText="Note"
                            width="200"
                          ></e-column>
                        </e-columns>
                      </ejs-grid>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <b-tab
          title="Recite"
          @click="tabClicked('dialogATab03')"
          v-if="this.spettacoliActiveId"
        >
          <b-row class="match-height">
            <!-- Card Grid View: GridElencoRecite -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Elenco Recite</b-card-title>
                    <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Timer Alert -->
                    <b-col xl="6" md="12">
                      <b-alert
                        :show="alertADismissCountDown"
                        dismissible
                        variant="warning"
                        @dismissed="alertADismissCountDown = 0"
                        @dismiss-count-down="alertACountDownChanged"
                      >
                        <p>Occorre selezionare una riga della tabella</p>
                        <b-progress
                          variant="warning"
                          :max="alertADismissSecs"
                          :value="alertADismissCountDown"
                          height="4px"
                        />
                      </b-alert>
                    </b-col>

                    <b-col xl="12" md="12" class="pt-1">
                      <ejs-grid
                        id="gridD"
                        ref="gridD"
                        :dataSource="reciteSpettacoloFullData"
                        :allowSorting="true"
                        :toolbarClick="gridDClickHandler"
                        :toolbar="gridD.toolbarOptions"
                        :height="gridD.height"
                        :allowFiltering="true"
                        :filterSettings="gridD.filterOptions"
                        :editSettings="gridD.editOptions"
                        :actionBegin="gridDactionBegin"
                        :actionComplete="gridDactionComplete"
                      >
                        <e-columns>
                          <e-column
                            field="id"
                            headerText="ID"
                            :isPrimaryKey="true"
                            width="30"
                          ></e-column>
                          <e-column
                            field="spettacolo"
                            headerText="Spettacolo"
                            width="60"
                            foreignKeyField="id"
                            foreignKeyValue="titolo"
                            :dataSource="this.spettacoliFullData"
                          ></e-column>
                          <e-column
                            field="data"
                            headerText="Data"
                            :format="settings.formatoData"
                            type="date"
                            width="100"
                          ></e-column>
                          <e-column
                            field="orario"
                            headerText="Orario"
                            type="time"
                            format="settings.formatoOraGrid"
                            width="60"
                          ></e-column>
                          <e-column
                            field="luogo"
                            headerText="Luogo"
                            width="60"
                          ></e-column>
                           <e-column
                            field="rassegna"
                            headerText="Rassegna"
                            width="60"
                            foreignKeyField="val"
                            foreignKeyValue="label"
                            :dataSource="this.spettacoliRassegnaList"
                          ></e-column>
                          <e-column
                            field="capienza"
                            headerText="Capienza"
                            width="60"
                          ></e-column>
                          <e-column
                            field="vigiliFuoco"
                            headerText="Vigili del Fuoco"
                            width="60"
                          ></e-column>
                          <e-column
                            field="siae"
                            headerText="Siae"
                            width="60"
                          ></e-column>
                        </e-columns>
                      </ejs-grid>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <b-tab
          title="Vigili del Fuoco"
          v-if="nonMostrare"
          @click="tabClicked('dialogATab04')"
        >
          <b-row class="match-height">
            <!-- Card Grid View: GridScrittureArtistiche -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Vigili del Fuoco</b-card-title>
                    <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row> </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <b-tab
          title="Siae"
          v-if="nonMostrare"
          @click="tabClicked('dialogATab05')"
        >
          <b-row class="match-height">
            <!-- Card Grid View: GridScrittureArtistiche -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Siae</b-card-title>
                    <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row> </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <b-tab
          title="Calendario Ministero Preventivo"
          v-if="this.spettacoliActiveId && this.spettacoliActiveData.ministero"
          @click="tabClicked('dialogATab06')"
        >
          <b-row class="match-height">
            <b-col xl="12" md="12" class="text-right mt-1">
                      <ejs-button id="calcolaCalendarioMinisteroPrevButton" cssClass="e-flat"
                        @click.native="calcolaCalendarioMinisteroPrev()">RECUPERA DATI PREVENTIVO</ejs-button>
                    </b-col>
            <!-- Card con Elementi Input: Dettaglio Calendario Preventivo 1 -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Calendario Preventivo 1</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinPrevDisciplina  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevDisciplina" class="h5">Disciplina</label>
                      <ejs-dropdownlist
                        id="calMinPrevDisciplina"
                        ref="calMinPrevDisciplina"
                        v-model="spettacoliActiveData.calMinPrevDisciplina"
                        :dataSource="calendarioMinisteroDisciplinaList"
                        :fields="calendarioMinisteroDisciplinaFields"
                        placeholder="Disciplina"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinPrevTipoAttivita  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevTipoAttivita" class="h5">Tipo Attività</label>
                      <ejs-dropdownlist
                        id="calMinPrevTipoAttivita"
                        v-model="spettacoliActiveData.calMinPrevTipoAttivita"
                        :dataSource="calendarioMinisteroTipoAttivitaList"
                        :fields="calendarioMinisteroTipoAttivitaFields"
                        placeholder="calMinPrevTipoAttivita"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevTitoloRepertorio  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevTitoloRepertorio" class="h5"
                        >Titolo/Repertorio</label
                      >
                      <ejs-textbox
                        id="calMinPrevTitoloRepertorio"
                        ref="calMinPrevTitoloRepertorio"
                        v-model="spettacoliActiveData.calMinPrevTitoloRepertorio"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Titolo/Repertorio"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevAutore  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevAutore" class="h5">Autore</label>
                      <ejs-textbox
                        id="calMinPrevAutore"
                        v-model="spettacoliActiveData.calMinPrevAutore"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Autore"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinPrevVivente -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="calMinPrevVivente" class="h5 mr-1">Vivente</label>
                        <ejs-checkbox
                          id="calMinPrevVivente"
                          v-model="spettacoliActiveData.calMinPrevVivente"
                          :checked="spettacoliActiveData.calMinPrevVivente"
                          name="calMinPrevVivente"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevNazAutore  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNazAutore" class="h5"
                        >Nazionalità Autore</label
                      >
                      <ejs-textbox
                        id="calMinPrevNazAutore"
                        v-model="spettacoliActiveData.calMinPrevNazAutore"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nazionalità Autore"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevRegCorDir  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevRegCorDir" class="h5"
                        >Regista/Coreografo/Direttore d'orchestra</label
                      >
                      <ejs-textbox
                        id="calMinPrevRegCorDir"
                        v-model="spettacoliActiveData.calMinPrevRegCorDir"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Regista/Coreografo/Direttore d'orchestra"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.calMinPrevInterpreti  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevInterpreti" class="h5"
                        >Intepreti principali/Solisti</label
                      >
                      <ejs-textbox
                        id="calMinPrevInterpreti"
                        v-model="spettacoliActiveData.calMinPrevInterpreti"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Intepreti principali/Solisti"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="6"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumeroTecnici -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNumeroTecnici" class="h5"
                        >Numero Tecnici</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevNumeroTecnici"
                        v-model="spettacoliActiveData.calMinPrevNumeroTecnici"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Tecnici"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumeroArtisti -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNumeroArtisti" class="h5"
                        >Numero Artisti</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevNumeroArtisti"
                        v-model="spettacoliActiveData.calMinPrevNumeroArtisti"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Artisti"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumeroProfOrchestraUE -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNumeroProfOrchestraUE" class="h5"
                        >Numero Professori d'Orchestra Italiani o UE</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevNumeroProfOrchestraUE"
                        v-model="
                          spettacoliActiveData.calMinPrevNumeroProfOrchestraUE
                        "
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Professori d'Orchestra Italiani o UE"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumeroProfOrchestraExtraUE -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNumeroProfOrchestraExtraUE" class="h5"
                        >Numero Professori d'Orchestra Extra UE</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevNumeroProfOrchestraExtraUE"
                        v-model="
                          spettacoliActiveData.calMinPrevNumeroProfOrchestraExtraUE
                        "
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Professori d'Orchestra Extra UE"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinPrevOperaDaCamera -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="calMinPrevOperaDaCamera" class="h5 mr-1"
                          >Opera da Camera</label
                        >
                        <ejs-checkbox
                          id="calMinPrevOperaDaCamera"
                          v-model="spettacoliActiveData.calMinPrevOperaDaCamera"
                          :checked="spettacoliActiveData.calMinPrevOperaDaCamera"
                          name="calMinPrevOperaDaCamera"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumeroProveGenerali -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNumeroProveGenerali" class="h5"
                        >Numero Prove Generali</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevNumeroProveGenerali"
                        v-model="
                          spettacoliActiveData.calMinPrevNumeroProveGenerali
                        "
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Prove Generali"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumeroProveAnteGenerali -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNumeroProveAnteGenerali" class="h5"
                        >Numero Prove Ante Generali</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevNumeroProveAnteGenerali"
                        v-model="
                          spettacoliActiveData.calMinPrevNumeroProveAnteGenerali
                        "
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Prove Ante Generali"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumeroProveNonApertePubblico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNumeroProveNonApertePubblico" class="h5"
                        >Numero Prove Non Aperte al Pubblico</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevNumeroProveNonApertePubblico"
                        v-model="
                          spettacoliActiveData.calMinPrevNumeroProveNonApertePubblico
                        "
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Prove Non Aperte al Pubblico"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo data: spettacoliActiveData.calMinPrevPeriodoDal -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevPeriodoDal" class="h5">Periodo dal</label>
                      <ejs-datepicker
                        id="calMinPrevPeriodoDal"
                        ref="calMinPrevPeriodoDal"
                        v-model="spettacoliActiveData.calMinPrevPeriodoDal"
                        :format="settings.formatoDatepicker"
                        placeholder="Periodo dal"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <!-- Input di tipo data: spettacoliActiveData.calMinPrevPeriodoAl -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevPeriodoAl" class="h5">Periodo al</label>
                      <ejs-datepicker
                        id="calMinPrevPeriodoAl"
                        ref="calMinPrevPeriodoAl"
                        v-model="spettacoliActiveData.calMinPrevPeriodoAl"
                        :format="settings.formatoDatepicker"
                        placeholder="Periodo al"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinPrevNuovaProduzione  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNuovaProduzione" class="h5"
                        >Nuova Produzione/Ripresa</label
                      >
                      <ejs-dropdownlist
                        id="calMinPrevNuovaProduzione"
                        v-model="spettacoliActiveData.calMinPrevNuovaProduzione"
                        :dataSource="calendarioMinisteroNuovaProduzioneList"
                        :fields="calendarioMinisteroNuovaProduzioneFields"
                        placeholder="Nuova Produzione/Ripresa"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinPrevProdotto  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevProdotto" class="h5">Prodotto/Ospitato</label>
                      <ejs-dropdownlist
                        id="calMinPrevProdotto"
                        v-model="spettacoliActiveData.calMinPrevProdotto"
                        :dataSource="calendarioMinisteroProdottoList"
                        :fields="calendarioMinisteroProdottoFields"
                        placeholder="Prodotto/Ospitato"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.calMinPrevCompagniaOspitato  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevProdotto=='ospitato'">
                      <label for="calMinPrevCompagniaOspitato" class="h5"
                        >Compagnia/Complessi/Artisti Ospitati</label
                      >
                      <ejs-textbox
                        id="calMinPrevCompagniaOspitato"
                        v-model="spettacoliActiveData.calMinPrevCompagniaOspitato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Compagnia/Complessi/Artisti Ospitati"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="3"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.calMinPrevDenominazioneOspitato  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevProdotto=='ospitato'">
                      <label for="calMinPrevDenominazioneOspitato" class="h5"
                        >Denominazione</label
                      >
                      <ejs-textbox
                        id="calMinPrevDenominazioneOspitato"
                        v-model="reciteSpettacoloActiveData.calMinPrevDenominazioneOspitato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Denominazione"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.calMinPrevCodFiscOspitato  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevProdotto=='ospitato'">
                      <label for="calMinPrevCodFiscOspitato" class="h5"
                        >Codice Fiscale</label
                      >
                      <ejs-textbox
                        id="calMinPrevCodFiscOspitato"
                        v-model="reciteSpettacoloActiveData.calMinPrevCodFiscOspitato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Codice Fiscale"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.calMinPrevPartIvaOspitato  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevProdotto=='ospitato'">
                      <label for="calMinPrevPartIvaOspitato" class="h5"
                        >Partita Iva</label
                      >
                      <ejs-textbox
                        id="calMinPrevPartIvaOspitato"
                        v-model="reciteSpettacoloActiveData.calMinPrevPartIvaOspitato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita Iva"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevNazOspitato  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevProdotto=='ospitato'">
                      <label for="calMinPrevNazOspitato" class="h5"
                        >Nazionalità</label
                      >
                      <ejs-textbox
                        id="calMinPrevNazOspitato"
                        v-model="spettacoliActiveData.calMinPrevNazOspitato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nazionalità"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinPrevUnder35Ospitato -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center" v-if="this.spettacoliActiveData.calMinPrevProdotto=='ospitato'">
                      <b-row class="m-0">
                        <label for="calMinPrevUnder35Ospitato" class="h5 mr-1">Under 35</label>
                        <ejs-checkbox
                          id="calMinPrevUnder35Ospitato"
                          v-model="spettacoliActiveData.calMinPrevUnder35Ospitato"
                          :checked="spettacoliActiveData.calMinPrevUnder35Ospitato"
                          name="calMinPrevUnder35Ospitato"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinPrevTipoCompensoOspitato  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevProdotto=='ospitato'">
                      <label for="calMinPrevTipoCompensoOspitato" class="h5">Tipo Compenso</label>
                      <ejs-dropdownlist
                        id="calMinPrevTipoCompensoOspitato"
                        v-model="spettacoliActiveData.calMinPrevTipoCompensoOspitato"
                        :dataSource="calendarioMinisteroTipoCompensoList"
                        :fields="calendarioMinisteroTipoCompensoFields"
                        placeholder="Tipo Compenso"
                      />
                    </b-col>





                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Dettaglio Calendario Preventivo 2 -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Calendario Preventivo 2</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinPrevCoproduzioneMin -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="calMinPrevCoproduzioneMin" class="h5 mr-1"
                          >Coproduzione</label
                        >
                        <ejs-checkbox
                          id="calMinPrevCoproduzioneMin"
                          ref="calMinPrevCoproduzioneMin"
                          v-model="spettacoliActiveData.calMinPrevCoproduzioneMin"
                          :checked="spettacoliActiveData.calMinPrevCoproduzioneMin"
                          name="calMinPrevCoproduzioneMin"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumCoproduttori -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevCoproduzioneMin">
                      <label for="calMinPrevNumCoproduttori" class="h5">Numero Coproduttori</label>
                      <ejs-numerictextbox
                        id="calMinPrevNumCoproduttori"
                        v-model="spettacoliActiveData.calMinPrevNumCoproduttori"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Coproduttori"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevNomeCoprod1  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>0">
                      <label for="calMinPrevNomeCoprod1" class="h5"
                        >Nome Coproduttore 1</label
                      >
                      <ejs-textbox
                        id="calMinPrevNomeCoprod1"
                        v-model="spettacoliActiveData.calMinPrevNomeCoprod1"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coproduttore 1"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevPartIvaCoprod1  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>0">
                      <label for="calMinPrevPartIvaCoprod1" class="h5"
                        >Partita Iva Coproduttore 1</label
                      >
                      <ejs-textbox
                        id="calMinPrevPartIvaCoprod1"
                        v-model="spettacoliActiveData.calMinPrevPartIvaCoprod1"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita IVA Coproduttore 1"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevPercCoprod1 -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>0">
                      <label for="calMinPrevPercCoprod1" class="h5">Percentuale Coproduttore 1</label>
                      <ejs-numerictextbox
                        id="calMinPrevPercCoprod1"
                        v-model="spettacoliActiveData.calMinPrevPercCoprod1"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Percentuale Coproduttore 1"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                     <!-- Input di tipo testo: spettacoliActiveData.calMinPrevNomeCoprod2  -->
                     <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>1">
                      <label for="calMinPrevNomeCoprod2" class="h5"
                        >Nome Coproduttore 2</label
                      >
                      <ejs-textbox
                        id="calMinPrevNomeCoprod2"
                        v-model="spettacoliActiveData.calMinPrevNomeCoprod2"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coproduttore 2"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevPartIvaCoprod2  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>1">
                      <label for="calMinPrevPartIvaCoprod2" class="h5"
                        >Partita Iva Coproduttore 2</label
                      >
                      <ejs-textbox
                        id="calMinPrevPartIvaCoprod2"
                        v-model="spettacoliActiveData.calMinPrevPartIvaCoprod2"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita IVA Coproduttore 2"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevPercCoprod2 -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>1">
                      <label for="calMinPrevPercCoprod2" class="h5">Percentuale Coproduttore 2</label>
                      <ejs-numerictextbox
                        id="calMinPrevPercCoprod2"
                        v-model="spettacoliActiveData.calMinPrevPercCoprod2"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Percentuale Coproduttore 2"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevNomeCoprod3  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>2">
                      <label for="calMinPrevNomeCoprod3" class="h5"
                        >Nome Coproduttore 3</label
                      >
                      <ejs-textbox
                        id="calMinPrevNomeCoprod3"
                        v-model="spettacoliActiveData.calMinPrevNomeCoprod3"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coproduttore 3"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevPartIvaCoprod3  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>2">
                      <label for="calMinPrevPartIvaCoprod3" class="h5"
                        >Partita Iva Coproduttore 3</label
                      >
                      <ejs-textbox
                        id="calMinPrevPartIvaCoprod3"
                        v-model="spettacoliActiveData.calMinPrevPartIvaCoprod3"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita IVA Coproduttore 3"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevPercCoprod3 -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>2">
                      <label for="calMinPrevPercCoprod3" class="h5">Percentuale Coproduttore 3</label>
                      <ejs-numerictextbox
                        id="calMinPrevPercCoprod3"
                        v-model="spettacoliActiveData.calMinPrevPercCoprod3"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Percentuale Coproduttore 3"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                     <!-- Input di tipo testo: spettacoliActiveData.calMinPrevNomeCoprod4  -->
                     <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>3">
                      <label for="calMinPrevNomeCoprod4" class="h5"
                        >Nome Coproduttore 4</label
                      >
                      <ejs-textbox
                        id="calMinPrevNomeCoprod4"
                        v-model="spettacoliActiveData.calMinPrevNomeCoprod4"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coproduttore 4"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevPartIvaCoprod4  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>3">
                      <label for="calMinPrevPartIvaCoprod4" class="h5"
                        >Partita Iva Coproduttore 4</label
                      >
                      <ejs-textbox
                        id="calMinPrevPartIvaCoprod4"
                        v-model="spettacoliActiveData.calMinPrevPartIvaCoprod4"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita IVA Coproduttore 4"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevPercCoprod4 -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>3">
                      <label for="calMinPrevPercCoprod4" class="h5">Percentuale Coproduttore 4</label>
                      <ejs-numerictextbox
                        id="calMinPrevPercCoprod4"
                        v-model="spettacoliActiveData.calMinPrevPercCoprod4"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Percentuale Coproduttore 4"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevNomeCoprod5  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>4">
                      <label for="calMinPrevNomeCoprod5" class="h5"
                        >Nome Coproduttore 5</label
                      >
                      <ejs-textbox
                        id="calMinPrevNomeCoprod5"
                        v-model="spettacoliActiveData.calMinPrevNomeCoprod5"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coproduttore 5"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevPartIvaCoprod5  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>4">
                      <label for="calMinPrevPartIvaCoprod5" class="h5"
                        >Partita Iva Coproduttore 5</label
                      >
                      <ejs-textbox
                        id="calMinPrevPartIvaCoprod5"
                        v-model="spettacoliActiveData.calMinPrevPartIvaCoprod5"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita IVA Coproduttore 5"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevPercCoprod5 -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinPrevNumCoproduttori>4">
                      <label for="calMinPrevPercCoprod5" class="h5">Percentuale Coproduttore 5</label>
                      <ejs-numerictextbox
                        id="calMinPrevPercCoprod5"
                        v-model="spettacoliActiveData.calMinPrevPercCoprod5"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Percentuale Coproduttore 5"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.calMinPrevCoprodNomePIva  -->
                    <!-- <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevCoprodNomePIva" class="h5"
                        >Se si: Nome Coproduttore e P.IVA</label
                      >
                      <ejs-textbox
                        id="calMinPrevCoprodNomePIva"
                        v-model="spettacoliActiveData.calMinPrevCoprodNomePIva"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coproduttore e P.IVA"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="2"
                      />
                    </b-col> -->

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevSede  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevSede" class="h5">Sede/Spazio</label>
                      <ejs-textbox
                        id="calMinPrevSede"
                        v-model="spettacoliActiveData.calMinPrevSede"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Sede/Spazio"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinPrevGestito -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="calMinPrevGestito" class="h5 mr-1">Gestito</label>
                        <ejs-checkbox
                          id="calMinPrevGestito"
                          v-model="spettacoliActiveData.calMinPrevGestito"
                          :checked="spettacoliActiveData.calMinPrevGestito"
                          name="calMinPrevGestito"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinPrevTipoCapienza  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevTipoCapienza" class="h5">Tipo Capienza</label>
                      <ejs-dropdownlist
                        id="calMinPrevTipoCapienza"
                        v-model="spettacoliActiveData.calMinPrevTipoCapienza"
                        :dataSource="calendarioMinisteroTipoCapienzaList"
                        :fields="calendarioMinisteroTipoCapienzaFields"
                        :change="onCalMinPrevTipoCapienzaChange"
                        placeholder="Prodotto/Ospitato"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevCapienza -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevCapienza" class="h5">Capienza</label>
                      <ejs-numerictextbox
                        id="calMinPrevCapienza"
                        v-model="spettacoliActiveData.calMinPrevCapienza"
                        floatLabelType="Never"
                        cssClass=""
                        format="### posti"
                        placeholder="Capienza"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevDimPalcoscenico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevDimPalcoscenico" class="h5"
                        >Dimensioni Palcoscenico</label
                      >
                      <ejs-textbox
                        id="calMinPrevDimPalcoscenico"
                        v-model="spettacoliActiveData.calMinPrevDimPalcoscenico"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Dimensioni Palcoscenico"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                      <!-- <ejs-numerictextbox
                        id="calMinPrevDimPalcoscenico"
                        v-model="spettacoliActiveData.calMinPrevDimPalcoscenico"
                        floatLabelType="Never"
                        cssClass=""
                        format="### m"
                        placeholder="Dimensioni Palcoscenico"
                        showSpinButton="false"
                        showClearButton="true"
                      /> -->
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevDimGolfoMistico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevDimGolfoMistico" class="h5"
                        >Dimensioni Golfo Mistico</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevDimGolfoMistico"
                        v-model="spettacoliActiveData.calMinPrevDimGolfoMistico"
                        floatLabelType="Never"
                        cssClass=""
                        format="###.## mq"
                        placeholder="Dimensioni Golfo Mistico"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevCarattAcustiche  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevCarattAcustiche" class="h5"
                        >Caratteristiche Acustiche</label
                      >
                      <ejs-textbox
                        id="calMinPrevCarattAcustiche"
                        v-model="spettacoliActiveData.calMinPrevCarattAcustiche"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Caratteristiche Acustiche"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumRecite -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNumRecite" class="h5"
                        >Numero Recite/Concerti/Manifestazioni</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevNumRecite"
                        v-model="spettacoliActiveData.calMinPrevNumRecite"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Recite/Concerti/Manifestazioni"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumReciteScuole -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNumReciteScuole" class="h5"
                        >Di cui Giornate e Mattine per Scuole</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevNumReciteScuole"
                        v-model="spettacoliActiveData.calMinPrevNumReciteScuole"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Di cui Giornate e Mattine per Scuole"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevGiornLavTerzi -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevGiornLavTerzi" class="h5"
                        >Giornate Lavorative Terzi</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevGiornLavTerzi"
                        v-model="spettacoliActiveData.calMinPrevGiornLavTerzi"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Giornate Lavorative Terzi"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinPrevIngressoGratuito  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevIngressoGratuito" class="h5"
                        >Ingresso Gratuito/A Pagamento</label
                      >
                      <ejs-dropdownlist
                        id="calMinPrevIngressoGratuito"
                        v-model="spettacoliActiveData.calMinPrevIngressoGratuito"
                        :dataSource="calendarioMinisteroIngressoGratuitoList"
                        :fields="calendarioMinisteroIngressoGratuitoFields"
                        placeholder="Ingresso Gratuito/A Pagamento"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumSpettatNoOmaggi -->
                    <!-- <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNumSpettatNoOmaggi" class="h5"
                        >Numero di Spettatori (al netto degli omaggi)</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevNumSpettatNoOmaggi"
                        v-model="spettacoliActiveData.calMinPrevNumSpettatNoOmaggi"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero di Spettatori (al netto degli omaggi)"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col> -->

                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinPrevStreaming -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="calMinPrevStreaming" class="h5 mr-1"
                          >Trasmissione in Modalità Streaming
                        </label>
                        <ejs-checkbox
                          id="calMinPrevStreaming"
                          v-model="spettacoliActiveData.calMinPrevStreaming"
                          :checked="spettacoliActiveData.calMinPrevStreaming"
                          name="calMinPrevStreaming"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinPrevEventoRiprogrammato -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="calMinPrevEventoRiprogrammato" class="h5 mr-1"
                          >Evento Riprogrammato</label
                        >
                        <ejs-checkbox
                          id="calMinPrevEventoRiprogrammato"
                          v-model="
                            spettacoliActiveData.calMinPrevEventoRiprogrammato
                          "
                          :checked="
                            spettacoliActiveData.calMinPrevEventoRiprogrammato
                          "
                          name="calMinPrevEventoRiprogrammato"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.calMinPrevCompagnia  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevCompagnia" class="h5"
                        >Compagnia di Canto con indicazione: Nome, Cognome, Ruolo, Nazionalità</label
                      >
                      <ejs-textbox
                        id="calMinPrevCompagnia"
                        v-model="spettacoliActiveData.calMinPrevCompagnia"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Compagnia di Canto con indicazione: Nome, Cognome, Ruolo, Nazionalità"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="6"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevOrchestraNome  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevOrchestraNome" class="h5">Orchestra</label>
                      <ejs-textbox
                        id="calMinPrevOrchestraNome"
                        v-model="spettacoliActiveData.calMinPrevOrchestraNome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Orchestra"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevOrchestraNaz  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevOrchestraNaz" class="h5"
                        >Nazionalità Orchestra</label
                      >
                      <ejs-textbox
                        id="calMinPrevOrchestraNaz"
                        v-model="spettacoliActiveData.calMinPrevOrchestraNaz"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nazionalità Orchestra"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevCoroNome  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevCoroNome" class="h5">Nome Coro</label>
                      <ejs-textbox
                        id="calMinPrevCoroNome"
                        v-model="spettacoliActiveData.calMinPrevCoroNome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coro"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumCoristi -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numCoristi" class="h5">Numero Coristi</label>
                      <ejs-numerictextbox
                        id="numCoristi"
                        v-model="spettacoliActiveData.calMinPrevNumCoristi"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Coristi"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevCoroNaz  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevCoroNaz" class="h5">Nazionalità Coro</label>
                      <ejs-textbox
                        id="calMinPrevCoroNaz"
                        v-model="spettacoliActiveData.calMinPrevCoroNaz"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nazionalità Orchestra"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinPrevNumCorpoBallo -->
                    <!-- <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevNumCorpoBallo" class="h5"
                        >Corpo di Ballo (se presente)</label
                      >
                      <ejs-numerictextbox
                        id="calMinPrevNumCorpoBallo"
                        v-model="spettacoliActiveData.calMinPrevNumCorpoBallo"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Corpo di Ballo"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col> -->

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevCorpoBallo  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevCorpoBallo" class="h5">Corpo di Ballo (se presente)</label>
                      <ejs-textbox
                        id="calMinPrevCorpoBallo"
                        v-model="spettacoliActiveData.calMinPrevCorpoBallo"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Corpo di Ballo"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinPrevCoreografoNome  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinPrevCoreografoNome" class="h5"
                        >Nome Coreografo</label
                      >
                      <ejs-textbox
                        id="calMinPrevCoreografoNome"
                        v-model="spettacoliActiveData.calMinPrevCoreografoNome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coreografo"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
        
        <b-tab
          title="Calendario Ministero Consuntivo"
          v-if="this.spettacoliActiveId && this.spettacoliActiveData.ministero"
          @click="tabClicked('dialogATab07')"
        >
          <b-row class="match-height">
            <b-col xl="12" md="12" class="text-right mt-1">
                      <ejs-button id="calcolaCalendarioMinisteroConsButton" cssClass="e-flat"
                        @click.native="calcolaCalendarioMinisteroCons()">RECUPERA DATI CONSUNTIVO</ejs-button>
                    </b-col>
            <!-- Card con Elementi Input: Dettaglio Calendario Consuntivo 1 -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Calendario Consuntivo 1</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinConsDisciplina  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsDisciplina" class="h5">Disciplina</label>
                      <ejs-dropdownlist
                        id="calMinConsDisciplina"
                        ref="calMinConsDisciplina"
                        v-model="spettacoliActiveData.calMinConsDisciplina"
                        :dataSource="calendarioMinisteroDisciplinaList"
                        :fields="calendarioMinisteroDisciplinaFields"
                        placeholder="Disciplina"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinConsTipoAttivita  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsTipoAttivita" class="h5">Tipo Attività</label>
                      <ejs-dropdownlist
                        id="calMinConsTipoAttivita"
                        v-model="spettacoliActiveData.calMinConsTipoAttivita"
                        :dataSource="calendarioMinisteroTipoAttivitaList"
                        :fields="calendarioMinisteroTipoAttivitaFields"
                        placeholder="calMinConsTipoAttivita"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsTitoloRepertorio  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsTitoloRepertorio" class="h5"
                        >Titolo/Repertorio</label
                      >
                      <ejs-textbox
                        id="calMinConsTitoloRepertorio"
                        ref="calMinConsTitoloRepertorio"
                        v-model="spettacoliActiveData.calMinConsTitoloRepertorio"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Titolo/Repertorio"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsAutore  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsAutore" class="h5">Autore</label>
                      <ejs-textbox
                        id="calMinConsAutore"
                        v-model="spettacoliActiveData.calMinConsAutore"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Autore"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinConsVivente -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="calMinConsVivente" class="h5 mr-1">Vivente</label>
                        <ejs-checkbox
                          id="calMinConsVivente"
                          v-model="spettacoliActiveData.calMinConsVivente"
                          :checked="spettacoliActiveData.calMinConsVivente"
                          name="calMinConsVivente"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsNazAutore  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNazAutore" class="h5"
                        >Nazionalità Autore</label
                      >
                      <ejs-textbox
                        id="calMinConsNazAutore"
                        v-model="spettacoliActiveData.calMinConsNazAutore"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nazionalità Autore"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsRegCorDir  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsRegCorDir" class="h5"
                        >Regista/Coreografo/Direttore d'orchestra</label
                      >
                      <ejs-textbox
                        id="calMinConsRegCorDir"
                        v-model="spettacoliActiveData.calMinConsRegCorDir"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Regista/Coreografo/Direttore d'orchestra"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.calMinConsInterpreti  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsInterpreti" class="h5"
                        >Intepreti principali/Solisti</label
                      >
                      <ejs-textbox
                        id="calMinConsInterpreti"
                        v-model="spettacoliActiveData.calMinConsInterpreti"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Intepreti principali/Solisti"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="6"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumeroTecnici -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNumeroTecnici" class="h5"
                        >Numero Tecnici</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsNumeroTecnici"
                        v-model="spettacoliActiveData.calMinConsNumeroTecnici"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Tecnici"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumeroArtisti -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNumeroArtisti" class="h5"
                        >Numero Artisti</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsNumeroArtisti"
                        v-model="spettacoliActiveData.calMinConsNumeroArtisti"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Artisti"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumeroProfOrchestraUE -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNumeroProfOrchestraUE" class="h5"
                        >Numero Professori d'Orchestra Italiani o UE</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsNumeroProfOrchestraUE"
                        v-model="
                          spettacoliActiveData.calMinConsNumeroProfOrchestraUE
                        "
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Professori d'Orchestra Italiani o UE"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumeroProfOrchestraExtraUE -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNumeroProfOrchestraExtraUE" class="h5"
                        >Numero Professori d'Orchestra Extra UE</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsNumeroProfOrchestraExtraUE"
                        v-model="
                          spettacoliActiveData.calMinConsNumeroProfOrchestraExtraUE
                        "
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Professori d'Orchestra Extra UE"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinConsOperaDaCamera -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="calMinConsOperaDaCamera" class="h5 mr-1"
                          >Opera da Camera</label
                        >
                        <ejs-checkbox
                          id="calMinConsOperaDaCamera"
                          v-model="spettacoliActiveData.calMinConsOperaDaCamera"
                          :checked="spettacoliActiveData.calMinConsOperaDaCamera"
                          name="calMinConsOperaDaCamera"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumeroProveGenerali -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNumeroProveGenerali" class="h5"
                        >Numero Prove Generali</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsNumeroProveGenerali"
                        v-model="
                          spettacoliActiveData.calMinConsNumeroProveGenerali
                        "
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Prove Generali"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumeroProveAnteGenerali -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNumeroProveAnteGenerali" class="h5"
                        >Numero Prove Ante Generali</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsNumeroProveAnteGenerali"
                        v-model="
                          spettacoliActiveData.calMinConsNumeroProveAnteGenerali
                        "
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Prove Ante Generali"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumeroProveNonApertePubblico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNumeroProveNonApertePubblico" class="h5"
                        >Numero Prove Non Aperte al Pubblico</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsNumeroProveNonApertePubblico"
                        v-model="
                          spettacoliActiveData.calMinConsNumeroProveNonApertePubblico
                        "
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Prove Non Aperte al Pubblico"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo data: spettacoliActiveData.calMinConsPeriodoDal -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsPeriodoDal" class="h5">Periodo dal</label>
                      <ejs-datepicker
                        id="calMinConsPeriodoDal"
                        ref="calMinConsPeriodoDal"
                        v-model="spettacoliActiveData.calMinConsPeriodoDal"
                        :format="settings.formatoDatepicker"
                        placeholder="Periodo dal"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <!-- Input di tipo data: spettacoliActiveData.calMinConsPeriodoAl -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsPeriodoAl" class="h5">Periodo al</label>
                      <ejs-datepicker
                        id="calMinConsPeriodoAl"
                        ref="calMinConsPeriodoAl"
                        v-model="spettacoliActiveData.calMinConsPeriodoAl"
                        :format="settings.formatoDatepicker"
                        placeholder="Periodo al"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinConsNuovaProduzione  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNuovaProduzione" class="h5"
                        >Nuova Produzione/Ripresa</label
                      >
                      <ejs-dropdownlist
                        id="calMinConsNuovaProduzione"
                        v-model="spettacoliActiveData.calMinConsNuovaProduzione"
                        :dataSource="calendarioMinisteroNuovaProduzioneList"
                        :fields="calendarioMinisteroNuovaProduzioneFields"
                        placeholder="Nuova Produzione/Ripresa"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinConsProdotto  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsProdotto" class="h5">Prodotto/Ospitato</label>
                      <ejs-dropdownlist
                        id="calMinConsProdotto"
                        v-model="spettacoliActiveData.calMinConsProdotto"
                        :dataSource="calendarioMinisteroProdottoList"
                        :fields="calendarioMinisteroProdottoFields"
                        placeholder="Prodotto/Ospitato"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.calMinConsCompagniaOspitato  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsProdotto=='ospitato'">
                      <label for="calMinConsCompagniaOspitato" class="h5"
                        >Compagnia/Complessi/Artisti Ospitati</label
                      >
                      <ejs-textbox
                        id="calMinConsCompagniaOspitato"
                        v-model="spettacoliActiveData.calMinConsCompagniaOspitato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Compagnia/Complessi/Artisti Ospitati"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="3"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.calMinConsDenominazioneOspitato  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsProdotto=='ospitato'">
                      <label for="calMinConsDenominazioneOspitato" class="h5"
                        >Denominazione</label
                      >
                      <ejs-textbox
                        id="calMinConsDenominazioneOspitato"
                        v-model="reciteSpettacoloActiveData.calMinConsDenominazioneOspitato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Denominazione"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.calMinConsCodFiscOspitato  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsProdotto=='ospitato'">
                      <label for="calMinConsCodFiscOspitato" class="h5"
                        >Codice Fiscale</label
                      >
                      <ejs-textbox
                        id="calMinConsCodFiscOspitato"
                        v-model="reciteSpettacoloActiveData.calMinConsCodFiscOspitato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Codice Fiscale"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.calMinConsPartIvaOspitato  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsProdotto=='ospitato'">
                      <label for="calMinConsPartIvaOspitato" class="h5"
                        >Partita Iva</label
                      >
                      <ejs-textbox
                        id="calMinConsPartIvaOspitato"
                        v-model="reciteSpettacoloActiveData.calMinConsPartIvaOspitato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita Iva"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsNazOspitato  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsProdotto=='ospitato'">
                      <label for="calMinConsNazOspitato" class="h5"
                        >Nazionalità</label
                      >
                      <ejs-textbox
                        id="calMinConsNazOspitato"
                        v-model="spettacoliActiveData.calMinConsNazOspitato"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nazionalità"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinConsUnder35Ospitato -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center" v-if="this.spettacoliActiveData.calMinConsProdotto=='ospitato'">
                      <b-row class="m-0">
                        <label for="calMinConsUnder35Ospitato" class="h5 mr-1">Under 35</label>
                        <ejs-checkbox
                          id="calMinConsUnder35Ospitato"
                          v-model="spettacoliActiveData.calMinConsUnder35Ospitato"
                          :checked="spettacoliActiveData.calMinConsUnder35Ospitato"
                          name="calMinConsUnder35Ospitato"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinConsTipoCompensoOspitato  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsProdotto=='ospitato'">
                      <label for="calMinConsTipoCompensoOspitato" class="h5">Tipo Compenso</label>
                      <ejs-dropdownlist
                        id="calMinConsTipoCompensoOspitato"
                        v-model="spettacoliActiveData.calMinConsTipoCompensoOspitato"
                        :dataSource="calendarioMinisteroTipoCompensoList"
                        :fields="calendarioMinisteroTipoCompensoFields"
                        placeholder="Tipo Compenso"
                      />
                    </b-col>





                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Dettaglio Calendario Consuntivo 2 -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Calendario Consuntivo 2</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinConsCoproduzioneMin -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="calMinConsCoproduzioneMin" class="h5 mr-1"
                          >Coproduzione</label
                        >
                        <ejs-checkbox
                          id="calMinConsCoproduzioneMin"
                          ref="calMinConsCoproduzioneMin"
                          v-model="spettacoliActiveData.calMinConsCoproduzioneMin"
                          :checked="spettacoliActiveData.calMinConsCoproduzioneMin"
                          name="calMinConsCoproduzioneMin"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumCoproduttori -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsCoproduzioneMin">
                      <label for="calMinConsNumCoproduttori" class="h5">Numero Coproduttori</label>
                      <ejs-numerictextbox
                        id="calMinConsNumCoproduttori"
                        v-model="spettacoliActiveData.calMinConsNumCoproduttori"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Coproduttori"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsNomeCoprod1  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>0">
                      <label for="calMinConsNomeCoprod1" class="h5"
                        >Nome Coproduttore 1</label
                      >
                      <ejs-textbox
                        id="calMinConsNomeCoprod1"
                        v-model="spettacoliActiveData.calMinConsNomeCoprod1"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coproduttore 1"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsPartIvaCoprod1  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>0">
                      <label for="calMinConsPartIvaCoprod1" class="h5"
                        >Partita Iva Coproduttore 1</label
                      >
                      <ejs-textbox
                        id="calMinConsPartIvaCoprod1"
                        v-model="spettacoliActiveData.calMinConsPartIvaCoprod1"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita IVA Coproduttore 1"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsPercCoprod1 -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>0">
                      <label for="calMinConsPercCoprod1" class="h5">Percentuale Coproduttore 1</label>
                      <ejs-numerictextbox
                        id="calMinConsPercCoprod1"
                        v-model="spettacoliActiveData.calMinConsPercCoprod1"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Percentuale Coproduttore 1"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                     <!-- Input di tipo testo: spettacoliActiveData.calMinConsNomeCoprod2  -->
                     <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>1">
                      <label for="calMinConsNomeCoprod2" class="h5"
                        >Nome Coproduttore 2</label
                      >
                      <ejs-textbox
                        id="calMinConsNomeCoprod2"
                        v-model="spettacoliActiveData.calMinConsNomeCoprod2"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coproduttore 2"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsPartIvaCoprod2  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>1">
                      <label for="calMinConsPartIvaCoprod2" class="h5"
                        >Partita Iva Coproduttore 2</label
                      >
                      <ejs-textbox
                        id="calMinConsPartIvaCoprod2"
                        v-model="spettacoliActiveData.calMinConsPartIvaCoprod2"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita IVA Coproduttore 2"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsPercCoprod2 -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>1">
                      <label for="calMinConsPercCoprod2" class="h5">Percentuale Coproduttore 2</label>
                      <ejs-numerictextbox
                        id="calMinConsPercCoprod2"
                        v-model="spettacoliActiveData.calMinConsPercCoprod2"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Percentuale Coproduttore 2"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsNomeCoprod3  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>2">
                      <label for="calMinConsNomeCoprod3" class="h5"
                        >Nome Coproduttore 3</label
                      >
                      <ejs-textbox
                        id="calMinConsNomeCoprod3"
                        v-model="spettacoliActiveData.calMinConsNomeCoprod3"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coproduttore 3"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsPartIvaCoprod3  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>2">
                      <label for="calMinConsPartIvaCoprod3" class="h5"
                        >Partita Iva Coproduttore 3</label
                      >
                      <ejs-textbox
                        id="calMinConsPartIvaCoprod3"
                        v-model="spettacoliActiveData.calMinConsPartIvaCoprod3"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita IVA Coproduttore 3"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsPercCoprod3 -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>2">
                      <label for="calMinConsPercCoprod3" class="h5">Percentuale Coproduttore 3</label>
                      <ejs-numerictextbox
                        id="calMinConsPercCoprod3"
                        v-model="spettacoliActiveData.calMinConsPercCoprod3"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Percentuale Coproduttore 3"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                     <!-- Input di tipo testo: spettacoliActiveData.calMinConsNomeCoprod4  -->
                     <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>3">
                      <label for="calMinConsNomeCoprod4" class="h5"
                        >Nome Coproduttore 4</label
                      >
                      <ejs-textbox
                        id="calMinConsNomeCoprod4"
                        v-model="spettacoliActiveData.calMinConsNomeCoprod4"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coproduttore 4"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsPartIvaCoprod4  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>3">
                      <label for="calMinConsPartIvaCoprod4" class="h5"
                        >Partita Iva Coproduttore 4</label
                      >
                      <ejs-textbox
                        id="calMinConsPartIvaCoprod4"
                        v-model="spettacoliActiveData.calMinConsPartIvaCoprod4"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita IVA Coproduttore 4"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsPercCoprod4 -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>3">
                      <label for="calMinConsPercCoprod4" class="h5">Percentuale Coproduttore 4</label>
                      <ejs-numerictextbox
                        id="calMinConsPercCoprod4"
                        v-model="spettacoliActiveData.calMinConsPercCoprod4"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Percentuale Coproduttore 4"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsNomeCoprod5  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>4">
                      <label for="calMinConsNomeCoprod5" class="h5"
                        >Nome Coproduttore 5</label
                      >
                      <ejs-textbox
                        id="calMinConsNomeCoprod5"
                        v-model="spettacoliActiveData.calMinConsNomeCoprod5"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coproduttore 5"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsPartIvaCoprod5  -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>4">
                      <label for="calMinConsPartIvaCoprod5" class="h5"
                        >Partita Iva Coproduttore 5</label
                      >
                      <ejs-textbox
                        id="calMinConsPartIvaCoprod5"
                        v-model="spettacoliActiveData.calMinConsPartIvaCoprod5"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Partita IVA Coproduttore 5"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsPercCoprod5 -->
                    <b-col xl="12" md="12" class="mb-2" v-if="this.spettacoliActiveData.calMinConsNumCoproduttori>4">
                      <label for="calMinConsPercCoprod5" class="h5">Percentuale Coproduttore 5</label>
                      <ejs-numerictextbox
                        id="calMinConsPercCoprod5"
                        v-model="spettacoliActiveData.calMinConsPercCoprod5"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Percentuale Coproduttore 5"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.calMinConsCoprodNomePIva  -->
                    <!-- <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsCoprodNomePIva" class="h5"
                        >Se si: Nome Coproduttore e P.IVA</label
                      >
                      <ejs-textbox
                        id="calMinConsCoprodNomePIva"
                        v-model="spettacoliActiveData.calMinConsCoprodNomePIva"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coproduttore e P.IVA"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="2"
                      />
                    </b-col> -->

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsSede  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsSede" class="h5">Sede/Spazio</label>
                      <ejs-textbox
                        id="calMinConsSede"
                        v-model="spettacoliActiveData.calMinConsSede"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Sede/Spazio"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinConsGestito -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="calMinConsGestito" class="h5 mr-1">Gestito</label>
                        <ejs-checkbox
                          id="calMinConsGestito"
                          v-model="spettacoliActiveData.calMinConsGestito"
                          :checked="spettacoliActiveData.calMinConsGestito"
                          name="calMinConsGestito"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinConsTipoCapienza  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsTipoCapienza" class="h5">Tipo Capienza</label>
                      <ejs-dropdownlist
                        id="calMinConsTipoCapienza"
                        v-model="spettacoliActiveData.calMinConsTipoCapienza"
                        :dataSource="calendarioMinisteroTipoCapienzaList"
                        :fields="calendarioMinisteroTipoCapienzaFields"
                        :change="oncalMinConsTipoCapienzaChange"
                        placeholder="Prodotto/Ospitato"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsCapienza -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsCapienza" class="h5">Capienza</label>
                      <ejs-numerictextbox
                        id="calMinConsCapienza"
                        v-model="spettacoliActiveData.calMinConsCapienza"
                        floatLabelType="Never"
                        cssClass=""
                        format="### posti"
                        placeholder="Capienza"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsDimPalcoscenico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsDimPalcoscenico" class="h5"
                        >Dimensioni Palcoscenico</label
                      >
                      <ejs-textbox
                        id="calMinConsDimPalcoscenico"
                        v-model="spettacoliActiveData.calMinConsDimPalcoscenico"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Dimensioni Palcoscenico"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                      <!-- <ejs-numerictextbox
                        id="calMinConsDimPalcoscenico"
                        v-model="spettacoliActiveData.calMinConsDimPalcoscenico"
                        floatLabelType="Never"
                        cssClass=""
                        format="### m"
                        placeholder="Dimensioni Palcoscenico"
                        showSpinButton="false"
                        showClearButton="true"
                      /> -->
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsDimGolfoMistico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsDimGolfoMistico" class="h5"
                        >Dimensioni Golfo Mistico</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsDimGolfoMistico"
                        v-model="spettacoliActiveData.calMinConsDimGolfoMistico"
                        floatLabelType="Never"
                        cssClass=""
                        format="###.## mq"
                        placeholder="Dimensioni Golfo Mistico"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsCarattAcustiche  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsCarattAcustiche" class="h5"
                        >Caratteristiche Acustiche</label
                      >
                      <ejs-textbox
                        id="calMinConsCarattAcustiche"
                        v-model="spettacoliActiveData.calMinConsCarattAcustiche"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Caratteristiche Acustiche"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumRecite -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNumRecite" class="h5"
                        >Numero Recite/Concerti/Manifestazioni</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsNumRecite"
                        v-model="spettacoliActiveData.calMinConsNumRecite"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Recite/Concerti/Manifestazioni"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumReciteScuole -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNumReciteScuole" class="h5"
                        >Di cui Giornate e Mattine per Scuole</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsNumReciteScuole"
                        v-model="spettacoliActiveData.calMinConsNumReciteScuole"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Di cui Giornate e Mattine per Scuole"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsGiornLavTerzi -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsGiornLavTerzi" class="h5"
                        >Giornate Lavorative Terzi</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsGiornLavTerzi"
                        v-model="spettacoliActiveData.calMinConsGiornLavTerzi"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Giornate Lavorative Terzi"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: spettacoliActiveData.calMinConsIngressoGratuito  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsIngressoGratuito" class="h5"
                        >Ingresso Gratuito/A Pagamento</label
                      >
                      <ejs-dropdownlist
                        id="calMinConsIngressoGratuito"
                        v-model="spettacoliActiveData.calMinConsIngressoGratuito"
                        :dataSource="calendarioMinisteroIngressoGratuitoList"
                        :fields="calendarioMinisteroIngressoGratuitoFields"
                        placeholder="Ingresso Gratuito/A Pagamento"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumSpettatNoOmaggi -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNumSpettatNoOmaggi" class="h5"
                        >Numero di Spettatori (al netto degli omaggi)</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsNumSpettatNoOmaggi"
                        v-model="spettacoliActiveData.calMinConsNumSpettatNoOmaggi"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero di Spettatori (al netto degli omaggi)"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinConsStreaming -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="calMinConsStreaming" class="h5 mr-1"
                          >Trasmissione in Modalità Streaming
                        </label>
                        <ejs-checkbox
                          id="calMinConsStreaming"
                          v-model="spettacoliActiveData.calMinConsStreaming"
                          :checked="spettacoliActiveData.calMinConsStreaming"
                          name="calMinConsStreaming"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo checkbox: spettacoliActiveData.calMinConsEventoRiprogrammato -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="calMinConsEventoRiprogrammato" class="h5 mr-1"
                          >Evento Riprogrammato</label
                        >
                        <ejs-checkbox
                          id="calMinConsEventoRiprogrammato"
                          v-model="
                            spettacoliActiveData.calMinConsEventoRiprogrammato
                          "
                          :checked="
                            spettacoliActiveData.calMinConsEventoRiprogrammato
                          "
                          name="calMinConsEventoRiprogrammato"
                        />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo multilinea: spettacoliActiveData.calMinConsCompagnia  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsCompagnia" class="h5"
                        >Compagnia di Canto con indicazione: Nome, Cognome, Ruolo, Nazionalità</label
                      >
                      <ejs-textbox
                        id="calMinConsCompagnia"
                        v-model="spettacoliActiveData.calMinConsCompagnia"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Compagnia di Canto con indicazione: Nome, Cognome, Ruolo, Nazionalità"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :multiline="true"
                        :rows="6"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsOrchestraNome  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsOrchestraNome" class="h5">Orchestra</label>
                      <ejs-textbox
                        id="calMinConsOrchestraNome"
                        v-model="spettacoliActiveData.calMinConsOrchestraNome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Orchestra"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsOrchestraNaz  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsOrchestraNaz" class="h5"
                        >Nazionalità Orchestra</label
                      >
                      <ejs-textbox
                        id="calMinConsOrchestraNaz"
                        v-model="spettacoliActiveData.calMinConsOrchestraNaz"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nazionalità Orchestra"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsCoroNome  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsCoroNome" class="h5">Nome Coro</label>
                      <ejs-textbox
                        id="calMinConsCoroNome"
                        v-model="spettacoliActiveData.calMinConsCoroNome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coro"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumCoristi -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numCoristi" class="h5">Numero Coristi</label>
                      <ejs-numerictextbox
                        id="numCoristi"
                        v-model="spettacoliActiveData.calMinConsNumCoristi"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Numero Coristi"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsCoroNaz  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsCoroNaz" class="h5">Nazionalità Coro</label>
                      <ejs-textbox
                        id="calMinConsCoroNaz"
                        v-model="spettacoliActiveData.calMinConsCoroNaz"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nazionalità Orchestra"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo numero: spettacoliActiveData.calMinConsNumCorpoBallo -->
                    <!-- <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsNumCorpoBallo" class="h5"
                        >Corpo di Ballo (se presente)</label
                      >
                      <ejs-numerictextbox
                        id="calMinConsNumCorpoBallo"
                        v-model="spettacoliActiveData.calMinConsNumCorpoBallo"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Corpo di Ballo"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col> -->

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsCorpoBallo  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsCorpoBallo" class="h5">Corpo di Ballo (se presente)</label>
                      <ejs-textbox
                        id="calMinConsCorpoBallo"
                        v-model="spettacoliActiveData.calMinConsCorpoBallo"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Corpo di Ballo"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: spettacoliActiveData.calMinConsCoreografoNome  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="calMinConsCoreografoNome" class="h5"
                        >Nome Coreografo</label
                      >
                      <ejs-textbox
                        id="calMinConsCoreografoNome"
                        v-model="spettacoliActiveData.calMinConsCoreografoNome"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome Coreografo"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <!-- dialogB: dialogImmagineLocandina ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogB"
      ref="dialogB"
      :header="dialogB.header"
      :buttons="dialogB.buttons"
      :visible="dialogB.visible"
      :showCloseIcon="dialogB.showCloseIcon"
      :close="dialogBClose"
      :open="dialogBOpen"
      :zIndex="dialogB.zIndex"
      :animationSettings="dialogB.animationSettings"
      :isModal="dialogB.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogB" v-model="dialogB.tabAdialogBIndex">
        <b-tab
          title="Sostituzione Immagine"
          @click="tabClicked('dialogBTab01')"
        >
          <b-row class="match-height">
            <!-- Card con Elementi Input -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Informazioni nuova immagine</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo testo generico: imgSpettacoliActiveData.fileImmagine  -->
                    <!-- <b-col xl="12" md="12" class="mb-2">
                      <label for="fileImmagine" class="h5">Immagine attuale</label>
                      <ejs-textbox id="fileImmagine" v-model="imgSpettacoliActiveData.fileImmagine" floatLabelType="Never"
                        cssClass="" placeholder="Immagine attuale" showClearButton="true" type="text"
                        autocomplete="false" />
                    </b-col> -->

                    <!-- Input di tipo file upload -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="imagePreview" class="h5"
                        >Sostituzione Immagine</label
                      >
                      <ejs-uploader
                        id="imagePreview"
                        ref="uploadObj"
                        name="UploadFiles"
                        :async-settings="dialogBFileUpload.path"
                        :allowed-extensions="dialogBFileUpload.extensions"
                        :removing="addJWTHeaders"
                        :auto-upload="true"
                        :uploading="dialogBonFileUpload"
                        :success="dialogBafterUpload"
                        :drop-area="dialogBFileUpload.dropElement"
                        :buttons="dialogBFileUpload.buttons"
                      />
                    </b-col>

                    <!-- Input di tipo testo generico: imgSpettacoliActiveData.commento -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="commentiImmagine" class="h5">Commenti</label>
                      <ejs-textbox
                        id="commentiImmagine"
                        v-model="imgSpettacoliActiveData.commento"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Commenti"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con immagine fissa stile input -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Immagine</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo immagine -->
                    <b-col xl="12" md="12" class="mb-2">
                      <b-img
                        :src="imgSpettacoliActiveData.fileImmagine"
                        fluid
                        alt="Responsive image"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <!-- dialogD: dialogNuovodocSpettacolo ------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogD"
      ref="dialogD"
      :header="dialogD.header"
      :buttons="dialogD.buttons"
      :visible="dialogD.visible"
      :showCloseIcon="dialogD.showCloseIcon"
      :close="dialogDClose"
      :open="dialogDOpen"
      :zIndex="dialogD.zIndex"
      :animationSettings="dialogD.animationSettings"
      :isModal="dialogD.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogD" v-model="dialogD.tabAdialogDIndex">
        <b-tab title="Inserimento File" @click="tabClicked('dialogDTab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Informazioni File</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo testo generico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <!-- note da aggiungere? -->
                      <label for="tipologia" class="h5"
                        >Tipologia Documento</label
                      >
                      <ejs-textbox
                        id="tipologia"
                        v-model="docSpettacoloActiveData.tipologia"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo generico -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="note" class="h5">Note</label>
                      <ejs-textbox
                        id="note"
                        v-model="docSpettacoloActiveData.note"
                        floatLabelType="Never"
                        cssClass=""
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="scadenza" class="h5">Scadenza</label>
                      <ejs-datepicker
                        id="scadenza"
                        v-model="docSpettacoloActiveData.scadenza"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <!-- Timer Alert -->
                    <b-col xl="6" md="12">
                      <b-alert
                        :show="alertADismissCountDown"
                        dismissible
                        variant="warning"
                        @dismissed="alertADismissCountDown = 0"
                        @dismiss-count-down="alertACountDownChanged"
                      >
                        <p>Occorre selezionare una riga della tabella</p>
                        <b-progress
                          variant="warning"
                          :max="alertADismissSecs"
                          :value="alertADismissCountDown"
                          height="4px"
                        />
                      </b-alert>
                    </b-col>

                    <!-- grid dei file associati ad un documento -->
                    <b-col xl="12" md="12" class="pt-1">
                      <ejs-grid
                        id="gridC"
                        ref="gridC"
                        :dataSource="fileDocumentoFullData"
                        :allowSorting="true"
                        :toolbarClick="gridCClickHandler"
                        :toolbar="gridC.toolbarOptions"
                        :height="gridC.height"
                        :allowFiltering="true"
                        :filterSettings="gridC.filterOptions"
                        :editSettings="gridC.editOptions"
                        :actionBegin="gridCactionBegin"
                        :actionComplete="gridCactionComplete"
                      >
                        <e-columns>
                          <e-column
                            field="id"
                            headerText="ID"
                            :isPrimaryKey="true"
                            width="60"
                          ></e-column>
                          <e-column
                            field="etichetta"
                            headerText="Etichetta"
                            width="100"
                          ></e-column>
                          <e-column
                            field="fileDocumento"
                            headerText="Nome File"
                            width="100"
                          ></e-column>
                        </e-columns>
                      </ejs-grid>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <!-- dialogE: dialogNuovaRecita ------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogE"
      ref="dialogE"
      :header="dialogE.header"
      :buttons="dialogE.buttons"
      :visible="dialogE.visible"
      :showCloseIcon="dialogE.showCloseIcon"
      :close="dialogEClose"
      :open="dialogEOpen"
      :zIndex="dialogE.zIndex"
      :animationSettings="dialogE.animationSettings"
      :isModal="dialogE.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogE" v-model="dialogE.tabAdialogEIndex">
        <b-tab title="Inserimento File" @click="tabClicked('dialogETab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Informazioni Recita</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Input di tipo testo: reciteSpettacoloActiveData.id  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="id" class="h5">Id</label>
                      <ejs-textbox
                        id="id"
                        v-model="reciteSpettacoloActiveData.id"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Id"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.spettacolo  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="spettacolo" class="h5">Spettacolo</label>
                      <ejs-textbox
                        id="spettacolo"
                        v-model="reciteSpettacoloActiveData.spettacolo"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Spettacolo"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                        :readonly="true"
                      />
                    </b-col>

                    <!-- Input di tipo data: reciteSpettacoloActiveData.data -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="data" class="h5">Data</label>
                      <ejs-datepicker
                        id="data"
                        ref="data"
                        v-model="reciteSpettacoloActiveData.data"
                        :format="settings.formatoDatepicker"
                        placeholder="Data"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <!-- Input di tipo ora: reciteSpettacoloActiveData.orario -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="orario" class="h5">Orario Inizio</label>
                      <ejs-timepicker
                        id="orario"
                        ref="orario"
                        v-model="reciteSpettacoloActiveData.orario"
                        placeholder="Orario"
                        :step="settings.intervalloOra"
                        :format="settings.formatoOra"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.luogo  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="luogo" class="h5">Luogo</label>
                      <ejs-textbox
                        id="luogo"
                        v-model="reciteSpettacoloActiveData.luogo"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="luogo"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: reciteSpettacoloActiveData.rassegna  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="rassegna" class="h5">Rassegna</label>
                      <ejs-dropdownlist
                        id="rassegna"
                        v-model="reciteSpettacoloActiveData.rassegna"
                        :dataSource="spettacoliRassegnaList"
                        :fields="spettacoliRassegnaFields"
                        :allowFiltering="true"
                        placeholder="Rassegna"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.capienza  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="capienza" class="h5">Capienza</label>
                      <ejs-textbox
                        id="capienza"
                        v-model="reciteSpettacoloActiveData.capienza"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="capienza"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: reciteSpettacoloActiveData.tipologia  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tipologia" class="h5">Tipologia</label>
                      <ejs-dropdownlist
                        id="reciteTipologia"
                        v-model="reciteSpettacoloActiveData.tipologia"
                        :dataSource="reciteTipologiaList"
                        :fields="reciteTipologiaFields"
                        :allowFiltering="true"
                        placeholder="Tipologia"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: reciteSpettacoloActiveData.stato  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="stato" class="h5">Stato</label>
                      <ejs-dropdownlist
                        id="reciteStato"
                        v-model="reciteSpettacoloActiveData.stato"
                        :dataSource="reciteStatoList"
                        :fields="reciteStatoFields"
                        :allowFiltering="true"
                        placeholder="Stato"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.turno  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="turno" class="h5">Turno</label>
                      <ejs-textbox
                        id="turno"
                        v-model="reciteSpettacoloActiveData.turno"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="turno"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.idRecitaSITickets  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="idRecitaSITickets" class="h5"
                        >ID Recite SITickets (ID1, ID2, ID3, ..)</label
                      >
                      <ejs-textbox
                        id="idRecitaSITickets"
                        v-model="reciteSpettacoloActiveData.idRecitaSITickets"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="idRecitaSITickets"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.IVAOmaggi  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="IVAOmaggi" class="h5"
                        >IVA Eccedenza Omaggi (IVA ID1, IVA ID2, IVA ID3, ..)</label
                      >
                      <ejs-textbox
                        id="IVAOmaggi"
                        v-model="reciteSpettacoloActiveData.IVAOmaggi"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="IVAOmaggi"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.codiceStruttura  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="codiceStruttura" class="h5"
                        >Codice Struttura</label
                      >
                      <ejs-textbox
                        id="codiceStruttura"
                        v-model="reciteSpettacoloActiveData.codiceStruttura"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="codiceStruttura"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: reciteSpettacoloActiveData.vigiliFuoco  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="vigiliFuoco" class="h5"
                        >Vigili del Fuoco</label
                      >
                      <ejs-dropdownlist
                        id="vigiliFuoco"
                        v-model="reciteSpettacoloActiveData.vigiliFuoco"
                        :dataSource="reciteVigiliFuocoList"
                        :fields="reciteVigiliFuocoFields"
                        :allowFiltering="true"
                        placeholder="vigiliFuoco"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: reciteSpettacoloActiveData.siae  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="siae" class="h5">Siae</label>
                      <ejs-dropdownlist
                        id="siae"
                        v-model="reciteSpettacoloActiveData.siae"
                        :dataSource="reciteSiaeList"
                        :fields="reciteSiaeFields"
                        :allowFiltering="true"
                        placeholder="siae"
                      />
                    </b-col>

                    <!-- Input di tipo numero: reciteSpettacoloActiveData.durataPresuntaVVF -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="durataPresuntaVVF" class="h5"
                        >Durata Presunta per VVF</label
                      >
                      <ejs-numerictextbox
                        id="durataPresuntaVVF"
                        v-model="reciteSpettacoloActiveData.durataPresuntaVVF"
                        floatLabelType="Never"
                        cssClass=""
                        format="###"
                        placeholder="Durata Presunta VVF"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo testo: reciteSpettacoloActiveData.note  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="note" class="h5">Note</label>
                      <ejs-textbox
                        id="note"
                        v-model="reciteSpettacoloActiveData.note"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="note"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    

                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <!-- dialogI: dialogNuovoFileAllegato ------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogI"
      ref="dialogI"
      :header="dialogI.header"
      :buttons="dialogI.buttons"
      :visible="dialogI.visible"
      :showCloseIcon="dialogI.showCloseIcon"
      :close="dialogIClose"
      :open="dialogIOpen"
      :zIndex="dialogI.zIndex"
      :animationSettings="dialogI.animationSettings"
      :height="dialogI.height"
      :width="dialogI.width"
      :isModal="dialogI.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogI" v-model="dialogI.tabAdialogIIndex">
        <b-tab title="Nuovo File allegato" @click="tabClicked('dialogITab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title
                      >Informazioni nuovo file allegato</b-card-title
                    >
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown
                    variant="link"
                    no-caret
                    right
                    class="chart-dropdown"
                    toggle-class="p-0"
                  >
                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="18"
                        class="text-body cursor-pointer"
                      />
                    </template>
                    <b-dropdown-item href="#"> ... </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="etichettaAllegato" class="h5"
                        >Etichetta allegato</label
                      >
                      <ejs-textbox
                        id="etichettaAllegato"
                        ref="etichettaAllegato"
                        v-model="fileDocumentoActiveData.etichetta"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Nome file"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <!-- Input di tipo file upload -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="fileDocumento" class="h5"
                        >File allegato da caricare</label
                      >
                      <ejs-uploader
                        id="fileDocumento"
                        ref="fileDocumento"
                        name="fileDocumento"
                        :async-settings="dialogIFileUpload.path"
                        :allowed-extensions="dialogIFileUpload.extensions"
                        :removing="addJWTHeaders"
                        :auto-upload="true"
                        :uploading="dialogIonFileUpload"
                        :success="dialogIafterUpload"
                        :drop-area="dialogIFileUpload.dropElement"
                        :buttons="dialogIFileUpload.buttons"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <ejs-dialog
      id="dialogJ"
      ref="dialogJ"
      :header="dialogJ.header"
      :buttons="dialogJ.buttons"
      :visible="dialogJ.visible"
      :showCloseIcon="dialogJ.showCloseIcon"
      :close="dialogJClose"
      :open="dialogJOpen"
      :zIndex="dialogJ.zIndex"
      :animationSettings="dialogJ.animationSettings"
      :height="dialogJ.height"
      :width="dialogJ.width"
      :isModal="dialogJ.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogJ" v-model="dialogJ.tabAdialogJIndex">
        <b-tab title="Nuovo File allegato" @click="tabClicked('dialogJTab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Modifica etichetta allegato</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <b-col xl="12" md="12" class="mb-2">
                        <label for="etichettaAllegato" class="h5"
                          >Etichetta allegato</label
                        >
                        <ejs-textbox
                          id="etichettaAllegato"
                          ref="etichettaAllegato"
                          v-model="fileDocumentoActiveData.etichetta"
                          floatLabelType="Never"
                          cssClass=""
                          placeholder="Nome file"
                          showClearButton="true"
                          type="text"
                          autocomplete="false"
                        />
                      </b-col>
                      <label for="fileActions" class="h5"
                        >Azioni sul File</label
                      >
                      <b-row>
                        <b-col xl="12" md="12" class="text-left mb-1">
                          <ejs-button
                            id="fileDownload"
                            cssClass="e-flat"
                            @click.native="dialogJFileDownload()"
                          >
                            Scarica il File
                          </ejs-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  LinkPlugin,
  AlertPlugin,
  ToastPlugin,
} from "bootstrap-vue";
// import Vuexy

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
const apiVueEndPoint = process.env.VUE_APP_API_ENDPOINT;

const apiSpettacoliUrl = "/demo/api/spettacolo";
const apiSpettacoliRicercaUrl = "/demo/api/spettacolo/ricerca";
const apiReciteSpettacoloUrl = "/demo/api/recita/ricerca";
const apiRecitaUrl = "/demo/api/recita";
const apiDocSpettacoloUrl = "/demo/api/documento";
const apiFileDocumentoUrl = "/demo/api/filedocumento";
const apiImgSpettacoliUrl = "/demo/api/imgsoggetto"; // da implementare correttamente (collegare a id spettacolo)
const apiSpettacoloExportXlsUrl = "/demo/api/spettacolo/export_xls";

export default Vue.extend({
  components: {},
  data() {
    return {
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoOra: { skeleton: "Hm" },
        //formatoOra: 'HH:mm',
        formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },
      // spettacoli
      spettacoliFullData: [], // elenco completo dati spettacoli
      spettacoliActiveId: 0, // Id spettacolo attivo (0 se nuovo)
      spettacoliActiveData: {}, // dati completi dell spettacolo attivo
      spettacoliSavedData: {}, // dati completi dell spettacolo attivo
      spettacoliDefaultData: {}, // dati completi di default per nuovi spettacoli

      // per inizializzazione dropdown a null
      initIndex: -1,
      // per gestione stagioni
      stagioniData: [
          { label: "Anno 2022", val: "2022" },
          { label: "Anno 2023", val: "2023" },
          { label: "Anno 2024", val: "2024" },
          { label: "Anno 2025", val: "2025" },
          { label: "Anno 2026", val: "2026" },
          { label: "Anno 2027", val: "2027" },
      ],
      stagioniFields: { value: "val", text: "label" },
      stagioniIndex: -1,
      dataOggi: null,
      queryStagioni: null,
      stagioneCorrente: null,
      booleanList: [
        { label: "Si", val: true },
        { label: "No", val: false },
      ],
      // lista valori stagione spettacolo
      spettacoliStagioneList: [
        { label: "2022", val: "2022" },
        { label: "2023", val: "2023" },
        { label: "2024", val: "2024" },
        { label: "2025", val: "2025" },
        { label: "2026", val: "2026" },
        { label: "2027", val: "2027" },
      ],
      spettacoliStagioneFields: { text: "label", value: "val" },
      // lista valori tipologia spettacolo (aggiornato rispetto a tabella NATURA siTickets)
      spettacoliTipologiaList: [
        { label: "N01 - Opera", val: "N01Opera" },
        { label: "N02 - Balletto", val: "N02Balletto" },
        { label: "N03 - Prosa", val: "N03Prosa" },
        { label: "N04 - Musical", val: "N04Musical" },
        { label: "N05 - Concerto Classico", val: "N05ConcertoClassico" },
        { label: "N06 - Concerto Jazz", val: "N06ConcertoJazz" },
        { label: "N07 - Operetta", val: "N07Operetta" },
        {
          label: "N08 - Concerto Musica Leggera",
          val: "N08ConcertoMusicaLeggera",
        },
        { label: "N09 - Recital", val: "N09Recital" },
        { label: "N10 - Concerto di Danza", val: "N10ConcertodiDanza" },
        { label: "N11 - Mostra", val: "N11Mostra" },
        { label: "N12 - Manifestazione Mista", val: "N12ManifestazioneMista" },
        { label: "N13 - Burattini-Marionette", val: "N13BurattiniMarionette" },
        { label: "N14 - Arte Varia", val: "N14ArteVaria" },
        { label: "N15 - Circoteatro", val: "N15Circoteatro" },
        { label: "N16 - Eventi Diversi", val: "N16EventiDiversi" },
        { label: "N17 - Circo", val: "N17Circo" },
        { label: "N18 - Cinema", val: "N18Cinema" },
        { label: "N19 - Eventi diversi da spettacolo o intrattenimento", val: "N19EventiDiversi" },
        { label: "N20 - Concertino con musica dal vivo", val: "N20Concertino" },
      ],
      spettacoliTipologiaFields: { text: "label", value: "val" },
      // lista valori rassegna spettacolo
      spettacoliRassegnaList: [
        { label: "Nessuna", val: "nessuna" },
        { label: "Opera", val: "opera" },
        { label: "Danza", val: "danza" },
        { label: "Concerti", val: "concerti" },
        { label: "Prosa", val: "prosa" },
        { label: "Varietà", val: "varietà" },
        { label: "Comico", val: "comico" },
        { label: "Chi ha Paura del Melodramma?", val: "pauraMelodramma" },
        { label: "Teatro Scuola", val: "teatroScuola" },
        { label: "Eventi", val: "eventi" },
        { label: "Eventi Ospitati", val: "eventiOspitati" },
        { label: "Coccia d'Estate", val: "cocciaEstate" },
        { label: "Aperitivi in Jazz", val: "apeJazz" },
        { label: "Sinfonie di Sensi", val: "sinfonieSensi" },
        { label: "Servizi Biglietteria", val: "serviziBiglietteria" },
      ],
      spettacoliRassegnaFields: { text: "label", value: "val" },
      // lista valori stato spettacolo
      spettacoliStatoList: [
        { label: "Bozza", val: "bozza" },
        { label: "Confermato", val: "confermato" },
      ],
      spettacoliStatoFields: { text: "label", value: "val" },
      // lista valori organizzatore spettacolo
      spettacoliOrganizzatoreList: [
        { label: "Fondazione Teatro Carlo Coccia di Novara", val: "teatroCoccia" },
        { label: "A.N.C.O.R.A. Onlus", val: "A.N.C.O.R.A. Onlus" },
        { label: "A.N.G.S.A. Novara Vercelli", val: "A.N.G.S.A. Novara Vercelli" },
        { label: "A.S.D. DanzAria", val: "ASDDanzAria" },
        { label: "A.S.D. Danza Viva", val: "ASDDanzaViva" },
        { label: "AGIL VOLLEY SSD a r.l.", val: "AGIL VOLLEY SSD a r.l." },
        { label: "Associazione Brotherhood Gospel Choir", val: "brotherhood" },
        { label: "Associazione Culturale e di Promozione Sociale 'Inter Club Novara Nerazzurra'",
          val: "InterClubNovaraNerazzurra" },
        { label: "Associazione di Promozione Sociale Cabiria Teatro", val: "CabiriaTeatro" },
        { label: "Associazione Casa Alessia Onlus", val: "casaAlessia" },
        { label: "Associazione Culturale Circo e Teatro Dimidimitri",
          val: "circoTeatroDimidimitri" },
        { label: "Associazione Culturale LARIBALTA", val: "Associazione LARIBALTA" },
        { label: "Associazione Culturale Rest-Art E.T.S.", val: "restArt" },
        { label: "Associazione Dance Hall", val: "danceHall" },
        { label: "Associazione Erato", val: "erato" },
        { label: "Associazione For Life Onlus", val: "forLife" },
        { label: "Associazione Il Timone", val: "Associazione Il Timone" },
        { label: "Associazione Rest-Art E.T.S.", val: "Associazione Rest-Art E.T.S." },
        { label: "Associazione Nazionale Alpini", val: "alpini" },
        { label: "Civico Istituto Musicale Brera", val: "brera" },
        { label: "Comando dei Vigili del Fuoco della Provincia di Novara",
          val: "Comando dei Vigili del Fuoco della Provincia di Novara" },
        { label: "Comune di Novara", val: "comuneNovara" },
        { label: "Comunità Sant'Egidio Piemonte Onlus", val: "santEgidio" },
        { label: "Dance Live A.S.D.", val: "Dance Live A.S.D." },
        { label: "Deas Entertainment APS", val: "DEAS"},
        { label: "Demasound di De Marco Raffaele", val: "Demasound di De Marco Raffaele" },
        { label: "DNA - DANZA A.S.D.", val: "DNADanza" },
        { label: "Edizioni Radio di Ponzio Ugo & C S.a.s.", val: "EdizioniRadio"},
        { label: "FATTI SENTIRE Associazione Culturale", val: "fattiSentire" },
        { label: "Fondazione Arturo Toscanini", val: "Fondazione Arturo Toscanini" },
        { label: "Fondazione Circolo dei Lettori", val: "circoloLettori" },
        { label: "Fondazione Comoli Ferrari", val: "comoliFerrari" },
        { label: "Fondazione Piemonte dal Vivo", val: "piemonteDalVivo" },
        { label: "Friends&Partners S.p.A.", val: "Friends&Partners" },
        { label: "Heart Village S.S.D.R.L.", val: "Heart Village S.S.D.R.L." },
        { label: "I.S.S.M. Conservatorio Guido Cantelli di Novara",
          val: "conservatorioCantelli",
        },
        { label: "Istituto Tecnico Industriale Omar", val: "ITIOmar" },
        { label: "Liceo Artistico Musicale e Coreutico Statale 'Felice Casorati'", val: "liceoCasorati" },
        { label: "Polisportiva San Giacomo A.S.D.", val: "Polisportiva San Giacomo A.S.D." },
        { label: "Questura di Novara", val: "Questura di Novara" },
        { label: "S.C. AD Management s.r.l.", val: "SCAD Management srl"},
        { label: "Scuola del Teatro Musicale S.C.S.", val: "scuolaTeatroMusicale"},
        { label: "Studio Danza Novara A.S.D.", val: "studioDanzaNovara" },
        { label: "Tempio della Danza A.S.D.", val: "tempoDellaDanza" },
        { label: "Top Dance & Show A.S.D.", val: "topDance" },
        { label: "Unione Tutela Consumatori", val: "unioneTutelaConsumatori" },
        { label: "Unione Italiana dei Ciechi e degli Ipovedenti ONLUS/APS - Sezione Territoriale di Novara/Vco",
          val: "Unione Italiana dei Ciechi e degli Ipovedenti ONLUS/APS - Sezione Territoriale di Novara/Vco" },
        { label: "UISP Comitato Provinciale Novara", val: "UISP Comitato Provinciale Novara" },
        { label: "Vivo Concerti S.r.l.", val: "Vivo Concerti S.r.l."},
        { label: "Altro", val: "altro" },
      ],
      spettacoliOrganizzatoreFields: { text: "label", value: "val" },


      // calendario ministero

      calendarioMinisteroDisciplinaList: [
        { label: 'Musica', id: 'musica' },
        { label: 'Danza', id: 'danza' }], // elenco disciplina
      calendarioMinisteroDisciplinaFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista disciplina
      calendarioMinisteroTipoAttivitaList: [
        { label: 'Opera Lirica', id: 'operaLirica' },
        { label: 'Opera da Camera', id: 'operaDaCamera' },
        { label: 'Musical con Musica dal Vivo', id: 'musical' },
        { label: 'Operetta con Musica dal Vivo', id: 'operetta' },
        { label: 'Danza', id: 'danza' },
        { label: 'Concerti', id: 'concerti' }], // elenco tipologia attivita
      calendarioMinisteroTipoAttivitaFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista tipologia attivita
      calendarioMinisteroNuovaProduzioneList: [
        { label: 'Nuova Produzione', id: 'nuovaProduzione' },
        { label: 'Ripresa', id: 'ripresa' }], // elenco NuovaProduzione
      calendarioMinisteroNuovaProduzioneFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista NuovaProduzione
      calendarioMinisteroProdottoList: [
        { label: 'Prodotto', id: 'prodotto' },
        { label: 'Ospitato', id: 'ospitato' }], // elenco prodotto
      calendarioMinisteroProdottoFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista prodotto
      calendarioMinisteroIngressoGratuitoList: [
        { label: 'Gratuito', id: 'gratuito' },
        { label: 'A Pagamento', id: 'pagamento' }], // elenco IngressoGratuito
      calendarioMinisteroIngressoGratuitoFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista IngressoGratuito
      calendarioMinisteroTipoCapienzaList: [
        { label: 'Teatro Coccia 768', id: 'coccia768' },
        { label: 'Teatro Coccia 486', id: 'coccia486' },
        { label: 'Teatro Coccia 336', id: 'coccia336' },
        { label: 'Altro', id: 'altro' }], // elenco IngressoGratuito
      calendarioMinisteroTipoCapienzaFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista TipoCapienza
      calendarioMinisteroTipoCompensoList: [
        { label: 'Fisso', id: 'fisso' },
        { label: 'A percentuale', id: 'percentuale' }], // elenco tipoCompenso
      calendarioMinisteroTipoCompensoFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista TipoCompenso
      // docSpettacolo
      docSpettacoloFullData: [], // elenco completo dati documenti allegati spettacoli
      docSpettacoloActiveId: 0, // Id documento allegato spettacoli attivo (0 se nuovo)
      docSpettacoloActiveData: {}, // dati completi del documento allegato spettacoli attivo
      docSpettacoloDefaultData: {}, // dati completi di default per nuovi documenti allegato spettacoli
      // fileDocumento
      fileDocumentoFullData: [], // elenco completo dei file associati ad un DocumentoSpettacolo
      fileDocumentoActiveId: 0, // Id file documento attivo (0 se nuovo)
      fileDocumentoActiveData: {}, // dati completi del file attualmente visualizzato
      fileDocumentoDefaultData: {},
      // imgSpettacoli
      imgSpettacoliFullData: [], // elenco completo immagini spettacoli
      imgSpettacoliActiveId: 0, // Id immagine spettacoli attiva (0 se nuova)
      imgSpettacoliActiveData: {}, // dati completi della immagine spettacoli attiva
      imgSpettacoliDefaultData: {}, // dati completi di default per nuove immagini spettacoli
      // reciteSpettacolo
      reciteSpettacoloFullData: [], // elenco completo delle recite associate ad uno spettacolo
      reciteSpettacoloActiveId: 0, // Id recita attiva (0 se nuovo)
      reciteSpettacoloActiveData: {}, // dati completi della recita attualmente visualizzata
      reciteSpettacoloDefaultData: {},
      // lista valori tipologia recita
      reciteTipologiaList: [
        { label: "Rappresentazione", val: "rappresentazione" },
        { label: "Prova Generale", val: "provaGenerale" },
      ],
      reciteTipologiaFields: { text: "label", value: "val" },
      // lista valori stato recita
      reciteStatoList: [
        { label: "Confermata", val: "confermata" },
        { label: "Annullata", val: "annullata" },
      ],
      reciteStatoFields: { text: "label", value: "val" },
      // lista valori VigiliFuoco recita
      reciteVigiliFuocoList: [
        { label: "Non Necessari", val: "nonNecessari" },
        { label: "Comunicazione Effettuata", val: "comunicazioneEffettuata" },
        { label: "Comunicazione non Effettuata", val: "comunicazioneNonEffettuata" },
        { label: "Gestito da organizzatore", val: "gestitoOrganizzatore" },
      ],
      reciteVigiliFuocoFields: { text: "label", value: "val" },
      // lista valori Siae recita
      reciteSiaeList: [
        { label: "Non Necessaria", val: "nonNecessari" },
        { label: "Comunicazione Effettuata", val: "comunicazioneEffettuata" },
        {
          label: "Comunicazione non Effettuata",
          val: "comunicazioneNonEffettuata",
        },
      ],
      reciteSiaeFields: { text: "label", value: "val" },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: "",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogAOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogACancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogAIndex: 0,
        isModal: false,
      },
      // per dialogB
      dialogB: {
        header: "Sostituzione immagine locandina",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogBOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogBCancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FlipXUp", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogBIndex: 0,
        isModal: false,
      },
      // per dialogD
      dialogD: {
        header: "Nuovo Documento spettacolo",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogDOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogDCancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FlipXUp", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1060,
        tabAdialogDIndex: 0,
        isModal: false,
      },
      // per dialogE
      dialogE: {
        header: "Nuova Recita",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogEOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogECancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FlipXUp", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1060,
        tabAdialogEIndex: 0,
        isModal: false,
      },
      // per dialogI
      dialogI: {
        header: "Nuovo file allegato",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogIOk,
            buttonModel: { content: "OKKK", isPrimary: true },
          },
          { click: this.dialogICancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FlipXUp", duration: 400, delay: 0 },
        zIndex: 1070,
        tabAdialogIIndex: 0,
        height: "80%",
        width: "80%",
        isModal: true,
      },
      // per dialogJ
      dialogJ: {
        header: "Modifica file allegato",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogJOk,
            buttonModel: { content: "Salva", isPrimary: true },
          },
          { click: this.dialogJCancel, buttonModel: { content: "Annulla" } },
        ],
        animationSettings: { effect: "FlipXUp", duration: 400, delay: 0 },
        zIndex: 1070,
        tabAdialogJIndex: 0,
        height: "80%",
        width: "80%",
        isModal: true,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo Spettacolo",
            tooltipText: "Inserisci nuovo spettacolo",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Modifica Spettacolo",
            tooltipText: "Modifica spettacolo",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Cancella Spettacolo",
            tooltipText: "Cancella spettacolo",
            prefixIcon: "e-cancel",
            id: "delete",
          },
            "Search",
        ],
        sortOptions: { columns: [{ field: "dataInizio", direction: "Ascending" }] },
      },
      // per gridB
      gridBFlag: false,
      gridB: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo",
            tooltipText: "Inserisci nuovo documento",
            prefixIcon: "e-plus",
            id: "newDoc",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica documento",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Elimina",
            tooltipText: "Cancella documento",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          {
            text: "Scarica",
            tooltipText: "Scarica documento",
            prefixIcon: "e-save",
            id: "download",
          },
            "Search",
        ],
      },
      // per gridC di gestione fileDocumento
      gridC: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo",
            tooltipText: "Inserisci nuovo file",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica file",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Elimina",
            tooltipText: "Cancella file",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          {
            text: "Scarica",
            tooltipText: "Scarica file",
            prefixIcon: "e-save",
            id: "download",
          },
            "Search",
        ],
      },
      // per gridD
      gridDFlag: false,
      gridD: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuova",
            tooltipText: "Inserisci nuova recita",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Cancella",
            tooltipText: "Cancella",
            prefixIcon: "e-cancel",
            id: "delete",
          },
            "Search",
        ],
      }, //
      //
      // dati per dialogB fileUpload
      dialogBFileUpload: {
        path: {
          saveUrl: apiVueEndPoint + apiImgSpettacoliUrl,
          //removeUrl: `${apiVueEndPoint + apiImgSpettacoliUrl}/remove`, // ??
        },
        extensions: ".jpg, .png",
        dropElement: ".control-fluid",
        buttons: {
          browse: "Seleziona un file",
        },
      },
      dialogIFileUpload: {
        path: {
          saveUrl: apiVueEndPoint + apiFileDocumentoUrl,
          //removeUrl: `${apiVueEndPoint + apiImgSpettacoliUrl}/remove`, //??
        },
        extensions: ".jpg, .png, .pdf",
        dropElement: ".control-fluid",
        buttons: {
          browse: "Seleziona un file",
        },
      },
    };
  },
  created() {
    console.log("Pagina Spettacoli Creata");
    this.dataOggi = new Date()
    this.stagioneCorrente = this.dataOggi.getFullYear().toString()
    // inizializzazione elenchi dal backend
    // chiamate API

    // recupero elenco spettacoli dal backend
    if (localStorage.getItem("userData") !== null) {
      console.log("Recupero elenco spettacoli dal backend");
      const datiDaInviare = {
        stagione: this.stagioneCorrente,
      };
      useJwt.post(apiSpettacoliRicercaUrl, datiDaInviare).then((d) => {
        //console.log("SPETTACOLI");
        //console.log(d.data);
        this.spettacoliFullData = d.data;
      });
    } else {
      console.log("Non trovo UserData, prova ancora");
    }

    // Recupero/definisco i valori di default delle entità utilizzate nel componente

    // spettacoliDefaultData ( esplicitato nei pulsanti "Nuovo.." della gridA )
    this.spettacoliDefaultData = {};

    // docSpettacoloDefaultData
    this.docSpettacoloDefaultData = {
      id: 0,
      note: "",
      tipologia: "",
      scadenza: "",
    };

    this.fileDocumentoDefaultData = {
      id: 0,
      etichetta: "",
    };

    // imgSpettacoliDefaultData
    this.imgSpettacoliDefaultData = {
      id: 0,
      fileImmagine: "https://picsum.photos/1024/400/?image=51",
                 commento: "",
        };
    },

           provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
    methods: {
    downloadXls: function() {
      let datiDaInviare = {stagione: this.stagioneCorrente}

        useJwt.post(apiSpettacoloExportXlsUrl, datiDaInviare, { responseType: "blob" }).then((r)=>{
            console.log(r.headers)
            // let fileName = r.headers["content-disposition"].split("filename=")[1];
            const url = window.URL.createObjectURL(new Blob([r.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `elenco_spettacoli_${this.stagioneCorrente}.xlsx`);
            document.body.appendChild(link);
            link.click();
        }).catch((error) => {
            console.log(error)
        });
    },
    onStagioneChange: function (e) {
      console.log("Change")
      console.log("Recupero elenco spettacoli dal backend per l'anno selezionato");
      const datiDaInviare = {
        stagione: this.stagioneCorrente,
      };
      useJwt.post(apiSpettacoliRicercaUrl, datiDaInviare).then((d) => {
        //console.log("SPETTACOLI");
        //console.log(d.data);
        this.spettacoliFullData = d.data;
      });
    },
    // onCalMinPrevTipoCapienzaChange
    onCalMinPrevTipoCapienzaChange: function () {
      if (this.spettacoliActiveData.calMinPrevTipoCapienza == "coccia768") {
        this.spettacoliActiveData.calMinPrevCapienza = 768;
        this.spettacoliActiveData.calMinPrevDimPalcoscenico = "420 mq; spazio utile 224 mq";
        this.spettacoliActiveData.calMinPrevDimGolfoMistico = 76.95;
        this.spettacoliActiveData.calMinPrevCarattAcustiche = "Ottime";
      }
      else if (this.spettacoliActiveData.calMinPrevTipoCapienza == "coccia486") {
        this.spettacoliActiveData.calMinPrevCapienza = 486;
        this.spettacoliActiveData.calMinPrevDimPalcoscenico = "420 mq; spazio utile 224 mq";
        this.spettacoliActiveData.calMinPrevDimGolfoMistico = 76.95;
        this.spettacoliActiveData.calMinPrevCarattAcustiche = "Ottime";
      }
      else if (this.spettacoliActiveData.calMinPrevTipoCapienza == "coccia336") {
        this.spettacoliActiveData.calMinPrevCapienza = 336;
        this.spettacoliActiveData.calMinPrevDimPalcoscenico = "420 mq; spazio utile 224 mq";
        this.spettacoliActiveData.calMinPrevDimGolfoMistico = 76.95;
        this.spettacoliActiveData.calMinPrevCarattAcustiche = "Ottime";
      }  
      else if (this.spettacoliActiveData.calMinPrevTipoCapienza == "altro") {
        this.spettacoliActiveData.calMinPrevCapienza = null;
        this.spettacoliActiveData.calMinPrevDimPalcoscenico = null;
        this.spettacoliActiveData.calMinPrevDimGolfoMistico = null;
        this.spettacoliActiveData.calMinPrevCarattAcustiche = null;
      }
    },
    // oncalMinConsTipoCapienzaChange
    oncalMinConsTipoCapienzaChange: function () {
      if (this.spettacoliActiveData.calMinConsTipoCapienza == "coccia768") {
        this.spettacoliActiveData.calMinConsCapienza = 768;
        this.spettacoliActiveData.calMinConsDimPalcoscenico = "420 mq; spazio utile 224 mq";
        this.spettacoliActiveData.calMinConsDimGolfoMistico = 76.95;
        this.spettacoliActiveData.calMinConsCarattAcustiche = "Ottime";
      }
      else if (this.spettacoliActiveData.calMinConsTipoCapienza == "coccia486") {
        this.spettacoliActiveData.calMinConsCapienza = 486;
        this.spettacoliActiveData.calMinConsDimPalcoscenico = "420 mq; spazio utile 224 mq";
        this.spettacoliActiveData.calMinConsDimGolfoMistico = 76.95;
        this.spettacoliActiveData.calMinConsCarattAcustiche = "Ottime";
      }
      else if (this.spettacoliActiveData.calMinConsTipoCapienza == "coccia336") {
        this.spettacoliActiveData.calMinConsCapienza = 336;
        this.spettacoliActiveData.calMinConsDimPalcoscenico = "420 mq; spazio utile 224 mq";
        this.spettacoliActiveData.calMinConsDimGolfoMistico = 76.95;
        this.spettacoliActiveData.calMinConsCarattAcustiche = "Ottime";
      }  
      else if (this.spettacoliActiveData.calMinConsTipoCapienza == "altro") {
        this.spettacoliActiveData.calMinConsCapienza = null;
        this.spettacoliActiveData.calMinConsDimPalcoscenico = null;
        this.spettacoliActiveData.calMinConsDimGolfoMistico = null;
        this.spettacoliActiveData.calMinConsCarattAcustiche = null;
      }
    },
    // calcolaCalendarioMinisteroPrev
    calcolaCalendarioMinisteroPrev: function (e) {
      console.log("Calcola Calendario Ministero Preventivo")
      if (this.spettacoliActiveData.tipologia == "N02Balletto" || this.spettacoliActiveData.tipologia == "N10ConcertodiDanza") {
        this.spettacoliActiveData.calMinPrevDisciplina = "danza"
      }
      else {
        this.spettacoliActiveData.calMinPrevDisciplina = "musica"
      }
      // aggiorno il dropdown con i valori calcolati
      this.$refs.calMinPrevDisciplina.ej2Instances.value = this.spettacoliActiveData.calMinPrevDisciplina
      this.$refs.calMinPrevDisciplina.dataBind()

      this.spettacoliActiveData.calMinPrevTitoloRepertorio = this.spettacoliActiveData.titolo
      this.$refs.calMinPrevTitoloRepertorio.ej2Instances.value = this.spettacoliActiveData.calMinPrevTitoloRepertorio
      this.$refs.calMinPrevTitoloRepertorio.dataBind()

      this.spettacoliActiveData.calMinPrevPeriodoDal = this.spettacoliActiveData.dataInizio
      this.$refs.calMinPrevPeriodoDal.ej2Instances.value = this.spettacoliActiveData.calMinPrevPeriodoDal
      this.$refs.calMinPrevPeriodoDal.dataBind()

      this.spettacoliActiveData.calMinPrevPeriodoAl = this.spettacoliActiveData.dataFine
      this.$refs.calMinPrevPeriodoAl.ej2Instances.value = this.spettacoliActiveData.calMinPrevPeriodoAl
      this.$refs.calMinPrevPeriodoAl.dataBind()

      this.spettacoliActiveData.calMinPrevCoproduzioneMin = this.spettacoliActiveData.coproduzione
      this.$refs.calMinPrevCoproduzioneMin.ej2Instances.value = this.spettacoliActiveData.calMinPrevCoproduzioneMin
      this.$refs.calMinPrevCoproduzioneMin.dataBind()

    },
    // calcolaCalendarioMinisteroCons
    calcolaCalendarioMinisteroCons: function (e) {
      console.log("Calcola Calendario Ministero Consuntivo")
      if (this.spettacoliActiveData.tipologia == "N02Balletto" || this.spettacoliActiveData.tipologia == "N10ConcertodiDanza") {
        this.spettacoliActiveData.calMinConsDisciplina = "danza"
      }
      else {
        this.spettacoliActiveData.calMinConsDisciplina = "musica"
      }
      // aggiorno il dropdown con i valori calcolati
      this.$refs.calMinConsDisciplina.ej2Instances.value = this.spettacoliActiveData.calMinConsDisciplina
      this.$refs.calMinConsDisciplina.dataBind()

      this.spettacoliActiveData.calMinConsTitoloRepertorio = this.spettacoliActiveData.titolo
      this.$refs.calMinConsTitoloRepertorio.ej2Instances.value = this.spettacoliActiveData.calMinConsTitoloRepertorio
      this.$refs.calMinConsTitoloRepertorio.dataBind()

      this.spettacoliActiveData.calMinConsPeriodoDal = this.spettacoliActiveData.dataInizio
      this.$refs.calMinConsPeriodoDal.ej2Instances.value = this.spettacoliActiveData.calMinConsPeriodoDal
      this.$refs.calMinConsPeriodoDal.dataBind()

      this.spettacoliActiveData.calMinConsPeriodoAl = this.spettacoliActiveData.dataFine
      this.$refs.calMinConsPeriodoAl.ej2Instances.value = this.spettacoliActiveData.calMinConsPeriodoAl
      this.$refs.calMinConsPeriodoAl.dataBind()

      this.spettacoliActiveData.calMinConsCoproduzioneMin = this.spettacoliActiveData.coproduzione
      this.$refs.calMinConsCoproduzioneMin.ej2Instances.value = this.spettacoliActiveData.calMinConsCoproduzioneMin
      this.$refs.calMinConsCoproduzioneMin.dataBind()

    },
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    downloadFile(url, title) {
      const uninterceptedAxiosInstance = axios.create();
      uninterceptedAxiosInstance
        .get(url, {
          responseType: "arraybuffer",
          crossdomain: true,
        })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch(() => console.log("error occured"));
    },
    // per dialogA
    dialogAOpen(args) {
      console.log("Apertura dialogA");
      // assegnare le informazioni da visualizzare nel dialog A
      console.log("Spettacolo attivo");
      console.log(this.spettacoliActiveId);
      this.spettacoliSavedData = { ...this.spettacoliActiveData };
      this.imgSpettacoliActiveData = this.imgSpettacoliDefaultData;
      // this.imgSpettacoliActiveId = 0

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogAClose() {
      console.log("Chiusura dialogA");
      this.dialogA.tabAdialogAIndex = 0;
      console.log(this.spettacoliActiveData);
    },
    dialogAOk() {
      console.log("Cliccato bottone OK di dialogA");
      // salvataggio informazioni in remoto
      if (this.spettacoliActiveId === 0) {
        // salvataggio in caso di new
        useJwt
          .post(apiSpettacoliUrl, this.spettacoliActiveData)
          .then((res) => {
            // TODO: gestione errore creazione
            if (res.status == 200 || res.status == 201) {
              this.makeToast(
      "primary",
      "Successo",
      "Creazione dello spettacolo"
              );
            }
            console.log("SPETTACOLO CREATO");
            console.log(res.data);
            // mi segno ID elemento appena creato
            this.spettacoliActiveId = res.data.id;
            return this; // restituisci contesto per permettere aggiornamento grid
          })
          .then((context) => {
            const datiDaInviare = {
              stagione: this.stagioneCorrente,
            };
            useJwt.post(apiSpettacoliRicercaUrl, datiDaInviare).then((res) => {
              console.log(
            "Aggiornamento gridA con l'aggiunta di uno spettacolo"
              );
              context.spettacoliFullData = res.data;
              context.spettacoliFullData = [...context.spettacoliFullData];
            });
          });
      } else {
        // salvataggio in caso di edit
        const editUrl = `${apiSpettacoliUrl}/${this.spettacoliActiveId}`;
        // qui devo fare caricamento dati ma non include i file da gestire con upload
        useJwt
          .patch(editUrl, this.spettacoliActiveData)
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.makeToast(
                "primary",
                "Successo",
                "Modifica dello spettacolo"
              );
            }
            console.log(res.status);
            return this; // restituisci contesto per permettere aggiornamento gridA
          })
          .then((context) => {
            const datiDaInviare = {
              stagione: this.stagioneCorrente,
            };
            useJwt.post(apiSpettacoliRicercaUrl, datiDaInviare).then((res) => {
              console.log(
                "Aggiornamento gridA con la modifica di uno spettacolo"
              );
              context.spettacoliFullData = res.data;
              context.spettacoliFullData = [...context.spettacoliFullData];
            });
          });
      }
      this.$refs.dialogA.hide();
      // triggerare aggiornamento filtering / ordinamento? <----------------------
    },
    dialogACancel() {
      console.log("Cliccato bottone Cancel di dialogA");
      this.$refs.dialogA.hide();
    },
    // per dialogB
    dialogBOpenButtonClick() {
      this.imgSpettacoliActiveData.fileImmagine =
        this.spettacoliActiveData.immagineLocandina;
      this.imgSpettacoliActiveData.commento = "";
      this.$refs.dialogB.show(true);
    },
    dialogBOpen(args) {
      console.log("Apertura dialogB");
      // assegnare le informazioni da visualizzare nel dialogB

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogBClose() {
      console.log("Chiusura dialogB");
      // document.getElementById('dialogBOpenButton').style.display = '';
      this.dialogB.tabAdialogBIndex = 0;
    },
    dialogBOk() {
      console.log("Cliccato bottone OK di dialogB");
      // TODO......
      this.$refs.dialogB.hide();
    },
    dialogBCancel() {
      console.log("Cliccato bottone Cancel di dialogB");
      this.$refs.dialogB.hide();
    },
    dialogBonFileUpload(args) {
      const token = useJwt.getToken();

      useJwt.check(); // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader("Authorization", `Bearer ${token}`);
      // add addition data as key-value pair.
      args.customFormData = [{ soggetto_id: this.spettacoliActiveId }];
    },
    dialogBafterUpload(args) {
      console.log(args);
      if (args.name === "success") {
        console.log("tutto a posto");
        console.log(args.e.target.response);
        //const imgUrl = args.e.target.response
        const imgUrl = args.e.target.response.replace(/"/g, ""); // rimuovi apici dalla risposta ottenuta dal backend
        this.imgSpettacoliActiveData.fileImmagine = imgUrl;
        this.spettacoliActiveData.immagineLocandina = this.imgSpettacoliActiveData.fileImmagine;
        // TODO: reload immagine?
        // TODO: Salvare il spettacolo con immagineLocandina aggiornata?? <--------- PER FABIO
        console.log("salvo spettacolo con immagine aggiornata"); // aggiunta simo 19/01
        console.log(this.spettacoliActiveData.immagineLocandina); // aggiunta simo 19/01
        this.salvaSpettacolo(); // aggiunta simo 19/01
        this.$refs.uploadObj.clearAll(); // aggiunta simo 19/01
      }
    },
    // per dialogD
    dialogDOpen(args) {
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();

      console.log("Apertura dialogD");
      // assegnare le informazioni da visualizzare nel dialogD
      // devo fare una get da apiFileDocumentoUrl per ottenere la lista dei file associati a quel documentospettacolo

      useJwt
        .get(apiFileDocumentoUrl, { id: this.docSpettacoloActiveId })
        .then((d) => {
          console.log("DIALOGD get response");
          console.log(d.data);
          // usare questi dati per popolare la grid del dialogD
          this.fileDocumentoFullData = d.data;
          // trigger refresh della grid
        });
    },
    dialogDClose() {
      console.log("Chiusura dialogD");
      // document.getElementById('dialogDOpenButton').style.display = '';
      this.dialogD.tabAdialogDIndex = 0;
    },
    dialogDOk() {
      // voglio salvare un nuovo documentospettacolo
      console.log("Cliccato bottone OK di dialogD");

      if (this.docSpettacoloActiveId === 0) {
        this.docSpettacoloActiveData.soggetto = this.spettacoliActiveId; // associo ID spettacolo corrente

        console.log("voglio salvare queste info");
        console.log(this.docSpettacoloActiveData);
        console.log(`id spettacolo corrente (a cui associare il documento) ${this.spettacoliActiveId}`);

        useJwt
          .post(apiDocSpettacoloUrl, this.docSpettacoloActiveData)
          .then((res) => {
            console.log(res.status);
            console.log(res.data);
            this.docSpettacoloActiveId = res.data.id;
            this.docSpettacoloActiveData.id = res.data.id;
            this.docSpettacoloFullData.push(res.data);
            // refresh grid
            this.docSpettacoloFullData = [...this.docSpettacoloFullData];
          });
      } else {
        console.log("voglio salvare modifiche con queste info");
        // gestione modifica
        console.log(this.docSpettacoloActiveData);
        const editUrl = `${apiDocSpettacoloUrl}/${this.docSpettacoloActiveId}`;
        useJwt.patch(editUrl, this.docSpettacoloActiveData).then((res) => {
          console.log(res.status);
          console.log("INFO SALVATE E RESTITUITE");
          console.log(res.data);
          // ZZZZ

          console.log("Loop su fullData");
          console.log(this.docSpettacoloFullData);
          this.docSpettacoloFullData.forEach((obj) => {
            if (obj.id === res.data.id) {
              obj.tipologia = res.data.tipologia;
              obj.scadenza = res.data.scadenza;
              obj.note = res.data.note;
            }
          });
          // update grid
          this.docSpettacoloFullData = [...this.docSpettacoloFullData];
        });
      }
      this.$refs.dialogD.hide();
    },
    dialogDCancel() {
      console.log("Cliccato bottone Cancel di dialogD");
      this.$refs.dialogD.hide();
    },
    // per dialogE
    dialogEOpen(args) {
      console.log("Apertura dialogE");
      // assegnare le informazioni da visualizzare nel dialogE
      // trigger refresh della grid
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogEClose() {
      console.log("Chiusura dialogE");
      // document.getElementById('dialogEOpenButton').style.display = '';
      this.dialogE.tabAdialogEIndex = 0;
    },
    dialogEOk() {
      // voglio salvare recita
      console.log("Cliccato bottone OK di dialogE");

      // gestione new ed edit
      if (this.reciteSpettacoloActiveId === 0) {
        this.reciteSpettacoloActiveData.spettacolo = this.spettacoliActiveId; // associo ID spettacolo corrente

        console.log("voglio salvare queste info");
        console.log(this.reciteSpettacoloActiveData);

        console.log(`id spettacolo corrente (a cui associare la recita) ${this.spettacoliActiveId}`);

        useJwt
          .post(apiRecitaUrl, this.reciteSpettacoloActiveData)
          .then((res) => {
            console.log(res.status);
            console.log(res.data);
            this.reciteSpettacoloActiveId = res.data.id;
            this.reciteSpettacoloActiveData.id = res.data.id;
            this.reciteSpettacoloFullData.push(res.data);

            const i = this.reciteSpettacoloFullData.findIndex(
              (x) => x.id === this.reciteSpettacoloActiveId
            );
            if (i >= 0) {
              this.reciteSpettacoloFullData[i].orario =
                this.reciteSpettacoloFullData[i].orario.slice(11, 16);
            }

            // refresh grid
            this.reciteSpettacoloFullData = [...this.reciteSpettacoloFullData];
          });
      } else {
        console.log("voglio salvare modifiche con queste info");
        // gestione modifica
        console.log(this.reciteSpettacoloActiveData);
        const editUrl = `${apiRecitaUrl}/${this.reciteSpettacoloActiveId}`;
        useJwt.patch(editUrl, this.reciteSpettacoloActiveData).then((res) => {
          console.log(res.status);
          console.log("INFO SALVATE E RESTITUITE");
          console.log(res.data);

          // AAAA TODO: aggiornare reciteSpettacoloFullData
          const i = this.reciteSpettacoloFullData.findIndex(
            (x) => x.id === this.reciteSpettacoloActiveId
          );
          if (i >= 0) {
            this.reciteSpettacoloFullData[i] = res.data;
            // ritaglia orario
            this.reciteSpettacoloFullData[i].orario =
              this.reciteSpettacoloFullData[i].orario.slice(11, 16);
            // refresh grid
            this.reciteSpettacoloFullData = [...this.reciteSpettacoloFullData];
          }
        });
      }

      this.$refs.dialogE.hide();
    },
    dialogECancel() {
      console.log("Cliccato bottone Cancel di dialogE");
      this.$refs.dialogE.hide();
    },
    // per dialogI
    dialogIOpen(args) {
      console.log("Apertura dialogI");
      // assegnare le informazioni da visualizzare nel dialogE

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogIClose() {
      console.log("Chiusura dialogI");
      // document.getElementById('dialogEOpenButton').style.display = '';
      this.dialogI.tabAdialogEIndex = 0;
    },
    dialogIOk() {
      console.log("Cliccato bottone OK di dialogI");
      // TODO......
      this.$refs.dialogI.hide();
    },
    dialogICancel() {
      console.log("Cliccato bottone Cancel di dialogI");
      this.$refs.dialogI.hide();
    },
    dialogIonFileUpload(args) {
      // da sistemare
      const token = useJwt.getToken();

      useJwt.check(); // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader("Authorization", `Bearer ${token}`);
      // add addition data as key-value pair.
      args.customFormData = [
        { documentosoggetto_id: this.docSpettacoloActiveId },
        { etichetta: this.fileDocumentoActiveData.etichetta },
      ];
    },
    dialogIafterUpload(args) {
      console.log(args);
      if (args.name === "success") {
        this.makeToast(
          "primary",
          "Caricamento",
          "Caricamento file eseguito con successo"
        );
        // console.log('tutto a posto')
        // console.log(args.e.target.response)
        const r = JSON.parse(args.e.target.response);
        // refresh grid
        this.fileDocumentoFullData.push(r);
        this.fileDocumentoFullData = [...this.fileDocumentoFullData];

        this.fileDocumentoActiveId = 0;
        this.fileDocumentoActiveData = this.fileDocumentoDefaultData;
        this.$refs.fileDocumento.clearAll();
        // devo chiudere il dialog
        this.$refs.dialogI.hide();
      } else {
        this.makeToast("primary", "Caricamento", "Caricamento file fallito");
      }
    },
    // dialogJ
    dialogJOpen(args) {
      console.log("Apertura dialogJ");
      // assegnare le informazioni da visualizzare nel dialogE

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogJClose() {
      console.log("Chiusura dialogJ");
      this.dialogJ.tabAdialogEIndex = 0;
    },
    dialogJOk() {
      console.log("Cliccato bottone OK di dialogJ");
      // TODO......
      const editUrl = `${apiFileDocumentoUrl}/${this.fileDocumentoActiveId}`;
      useJwt
        .patch(editUrl, { etichetta: this.fileDocumentoActiveData.etichetta })
        .then((res) => {
          console.log(res.data);
          if (res.status === 200) {
            // se tutto OK
            this.makeToast(
              "primary",
              "Successo",
              "Salvataggio etichetta eseguito con successo"
            );
            // sostituisci in grid
            this.fileDocumentoFullData.forEach((obj) => {
              console.log(obj.id === res.data.id);
              if (obj.id === res.data.id) {
                obj.etichetta = res.data.etichetta;
                this.fileDocumentoFullData = [...this.fileDocumentoFullData];
              }
            });
          } else {
            this.makeToast(
              "primary",
              "Attenzione",
              "Salvataggio spettacolo non riuscito"
            );
          }
        });
      // salva etichetta
      console.log(this.fileDocumentoActiveData.etichetta);
      this.$refs.dialogJ.hide();
    },
    dialogJCancel() {
      console.log("Cliccato bottone Cancel di dialogJ");
      this.$refs.dialogJ.hide();
    },
    dialogJFileDownload() {
      this.makeToast(
        "info",
        "Azione",
        `Apri il file ${this.fileDocumentoActiveData.nome}`
      );
      // remove URL prefix and suffix from AWS filename
      const nomeFile = this.fileDocumentoActiveData.fileDocumento
        .split("\\")
        .pop()
        .split("/")
        .pop()
        .split("?")[0];
      console.log(`Nome file ${nomeFile}`);
      this.downloadFile(this.fileDocumentoActiveData.fileDocumento, nomeFile);
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        this.dialogA.header = "Nuovo Spettacolo";
        this.spettacoliDefaultData = {
          id: 0,
          titolo: "",
          tipologia: null,
          stato: null,
          stagione: null,
          rassegna: null,
          organizzatore: null,
          dataInizio: null,
          dataFine: null,
          descrizione: "",
          coproduzione: false,
          durataVVF: null,
          centroDiCosto: "",
          immagineLocandina: null,
          ministero: false,
          regione: false,
          comune: false,
          breve_descrizione: "",
          paragrafoQualitaArtistica: null,
          paragrafoInnovazione: null,
          paragrafoAttFormative: null,
          paragrafoMultidisciplinarieta: null,
          proventi: null,
          ospitalita: false,
          costoPrevisto: null,
          costoEffettivo: null,
          incassoPrevisto: null,
          incassoEffettivo: null,
          contributoCoproduzione: null,
          costoConsuntivoContabile: null,
          costoConsuntivoSmartControl: null,
          bilancioProduzioneValidato: false,
          // Calendario Ministero Preventivo
          calMinPrevDisciplina: null,
          calMinPrevTipoAttivita: null,
          calMinPrevTitoloRepertorio: null,
          calMinPrevAutore: null,
          calMinPrevVivente: false,
          calMinPrevNazAutore: null,
          calMinPrevRegCorDir: null,
          calMinPrevInterpreti: null,
          calMinPrevNumeroTecnici: null,
          calMinPrevNumeroArtisti: null,
          calMinPrevNumeroProfOrchestraUE: null,
          calMinPrevNumeroProfOrchestraExtraUE: null,
          calMinPrevOperaDaCamera: false,
          calMinPrevNumeroProveGenerali: null,
          calMinPrevNumeroProveAnteGenerali: null,
          calMinPrevNumeroProveNonApertePubblico: null,
          calMinPrevPeriodoDal: null,
          calMinPrevPeriodoAl: null,
          calMinPrevNuovaProduzione: null,
          calMinPrevProdotto: null,
          calMinPrevCompagniaOspitato: null,
          calMinPrevDenominazioneOspitato: null,
          calMinPrevCodFiscOspitato: null,
          calMinPrevPartIvaOspitato: null,
          calMinPrevNazOspitato: null,
          calMinPrevUnder35Ospitato: false,
          calMinPrevTipoCompensoOspitato: null,
          calMinPrevCoproduzioneMin: false,
          calMinPrevNumCoproduttori: null,
          calMinPrevNomeCoprod1: null,
          calMinPrevPartIvaCoprod1: null,
          calMinPrevPercCoprod1: null,
          calMinPrevNomeCoprod2: null,
          calMinPrevPartIvaCoprod2: null,
          calMinPrevPercCoprod2: null,
          calMinPrevNomeCoprod3: null,
          calMinPrevPartIvaCoprod3: null,
          calMinPrevPercCoprod3: null,
          calMinPrevNomeCoprod4: null,
          calMinPrevPartIvaCoprod4: null,
          calMinPrevPercCoprod4: null,
          calMinPrevNomeCoprod5: null,
          calMinPrevPartIvaCoprod5: null,
          calMinPrevPercCoprod5: null,
          calMinPrevSede: null,
          calMinPrevGestito: false,
          calMinPrevTipoCapienza: null,
          calMinPrevCapienza: null,
          calMinPrevDimPalcoscenico: null,
          calMinPrevDimGolfoMistico: null,
          calMinPrevCarattAcustiche: null,
          calMinPrevNumRecite: null,
          calMinPrevNumReciteScuole: null,
          calMinPrevGiornLavTerzi: null,
          calMinPrevIngressoGratuito: null,
          calMinPrevNumSpettatNoOmaggi: null,
          calMinPrevStreaming: false,
          calMinPrevEventoRiprogrammato: false,
          calMinPrevCompagnia: null,
          calMinPrevOrchestraNome: null,
          calMinPrevOrchestraNaz: null,
          calMinPrevCoroNome: null,
          calMinPrevNumCoristi: null,
          calMinPrevCoroNaz: null,
          calMinPrevNumCorpoBallo: null,
          calMinPrevCorpoBallo: null,
          calMinPrevCoreografoNome: null,
          // Calendario Ministero Consuntivo
          calMinConsDisciplina: null,
          calMinConsTipoAttivita: null,
          calMinConsTitoloRepertorio: null,
          calMinConsAutore: null,
          calMinConsVivente: false,
          calMinConsNazAutore: null,
          calMinConsRegCorDir: null,
          calMinConsInterpreti: null,
          calMinConsNumeroTecnici: null,
          calMinConsNumeroArtisti: null,
          calMinConsNumeroProfOrchestraUE: null,
          calMinConsNumeroProfOrchestraExtraUE: null,
          calMinConsOperaDaCamera: false,
          calMinConsNumeroProveGenerali: null,
          calMinConsNumeroProveAnteGenerali: null,
          calMinConsNumeroProveNonApertePubblico: null,
          calMinConsPeriodoDal: null,
          calMinConsPeriodoAl: null,
          calMinConsNuovaProduzione: null,
          calMinConsProdotto: null,
          calMinConsCompagniaOspitato: null,
          calMinConsDenominazioneOspitato: null,
          calMinConsCodFiscOspitato: null,
          calMinConsPartIvaOspitato: null,
          calMinConsNazOspitato: null,
          calMinConsUnder35Ospitato: false,
          calMinConsTipoCompensoOspitato: null,
          calMinConsCoproduzioneMin: false,
          calMinConsNumCoproduttori: null,
          calMinConsNomeCoprod1: null,
          calMinConsPartIvaCoprod1: null,
          calMinConsPercCoprod1: null,
          calMinConsNomeCoprod2: null,
          calMinConsPartIvaCoprod2: null,
          calMinConsPercCoprod2: null,
          calMinConsNomeCoprod3: null,
          calMinConsPartIvaCoprod3: null,
          calMinConsPercCoprod3: null,
          calMinConsNomeCoprod4: null,
          calMinConsPartIvaCoprod4: null,
          calMinConsPercCoprod4: null,
          calMinConsNomeCoprod5: null,
          calMinConsPartIvaCoprod5: null,
          calMinConsPercCoprod5: null,
          calMinConsSede: null,
          calMinConsGestito: false,
          calMinConsTipoCapienza: null,
          calMinConsCapienza: null,
          calMinConsDimPalcoscenico: null,
          calMinConsDimGolfoMistico: null,
          calMinConsCarattAcustiche: null,
          calMinConsNumRecite: null,
          calMinConsNumReciteScuole: null,
          calMinConsGiornLavTerzi: null,
          calMinConsIngressoGratuito: null,
          calMinConsNumSpettatNoOmaggi: null,
          calMinConsStreaming: false,
          calMinConsEventoRiprogrammato: false,
          calMinConsCompagnia: null,
          calMinConsOrchestraNome: null,
          calMinConsOrchestraNaz: null,
          calMinConsCoroNome: null,
          calMinConsNumCoristi: null,
          calMinConsCoroNaz: null,
          calMinConsNumCorpoBallo: null,
          calMinConsCorpoBallo: null,
          calMinConsCoreografoNome: null,
        };
        this.spettacoliActiveData = this.spettacoliDefaultData;
        console.log("Premuto pulsante creazione nuovo spettacolo da gridA");
        // console.log(this.spettacoliActiveData);
        // console.log(this.spettacoliDefaultData);
        this.spettacoliActiveId = 0;
        this.$refs.dialogA.show(true);
      }
      // pulsante EDIT
      else if (args.item.id === "edit") {
        console.log("Premuto pulsante modifica spettacolo da gridA");
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          let found = false;
          this.spettacoliActiveId = selectedRow[0].id;
          // console.log("gridA, Id selezionato:");
          console.log(this.spettacoliActiveId);
          const i = this.spettacoliFullData.findIndex(
            (x) => x.id === this.spettacoliActiveId
          );
          if (i >= 0) {
            this.spettacoliActiveData = this.spettacoliFullData[i];
            // this.spettacoliActiveData.immagineLocandina = "https://drf-coccia.s3.eu-south-1.amazonaws.com/drf-coccia/tmpImage_HB7y2N2.jpg" // aggiunto Simo 19/01
            console.log("SPETTACOLO CORRENTE");
            console.log(this.spettacoliActiveData);

            // AAAA Richiedi documenti associati al spettacolo corrente
            // const documentiSpettacoloUrl = `${process.env.VUE_APP_API_ENDPOINT}/${apiDocumentiUrl}/${this.spettacoliActiveId}`
            // useJwt.axiosIns.get(documentiSpettacoloUrl, { crossdomain: true }).then(res => {
            //   console.log(res.data['data']);
            //   this.docSpettacoloFullData = res.data['data']
            // });
            const datiDaInviare = {
              spettacolo: this.spettacoliActiveId,
            };
            useJwt.post(apiReciteSpettacoloUrl, datiDaInviare).then((d) => {
              // gestione risposta
              this.reciteSpettacoloFullData = d.data;
              console.log("Elenco recite collegate");
              console.log(this.reciteSpettacoloFullData);

              // fix aggiornamento orario
              this.reciteSpettacoloFullData.forEach((obj) => {
                if (obj.orario != null) {
                  //console.log(obj.orario.slice(11, 16));
                  obj.orario = obj.orario.slice(11, 16);
                }
              });
            });

            // spettacolo generico
            console.log("Edit spettacolo");
            this.dialogA.header = "Modifica Spettacolo";
            this.$refs.dialogA.show(true);
          } else {
            console.log("Elemento non trovato");
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
      // Pulsante DELETE
      else if (args.item.id === "delete") {
        try {
          console.log("Premuto pulsante elimina spettacolo da gridA");
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;

          const deleteUrl = `${apiSpettacoliUrl}/${deletedElementId}`;
          this.$refs.gridA.ej2Instances.deleteRecord();

          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
            // console.log(res.data)
          });
        } catch (err) {
          // da sistemare..............
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },
    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        // Add and edit operations
        if (e.requestType === "save") {
          const editedData = e.data;
          console.log(editedData);
          // The default edit operation is cancelled
          e.cancel = true;
          const editUrl = `${apiSpettacoliUrl}/${editedData.id}`;
          useJwt.patch(editUrl, editedData).then((res) => {
            console.log(res);
            if (res.status === 200) {
              // se tutto OK
              // Flag is enabled to skip this execution when grid ends add/edit
              this.gridAFlag = true;
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridA.endEdit();
            } else {
              this.makeToast(
                "primary",
                "Attenzione",
                "Salvataggio spettacolo non riuscito"
              );
            }
          });
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      if (e.requestType === "save") {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false;
      }
    },
    // per gridB
    gridBClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "newDoc") {
        console.log(
          "Premuto pulsante creazione nuovo documentospettacolo da gridB"
        );
        this.docSpettacoloActiveId = 0;

        this.docSpettacoloActiveData = this.docSpettacoloDefaultData;
        this.$refs.dialogD.show(true);
      } else if (args.item.id === "edit") {
        console.log("Premuto pulsante modifica documento allegato da gridB");
        try {
          const selectedRow = this.$refs.gridB.getSelectedRecords();
          let found = false;
          this.docSpettacoloActiveId = selectedRow[0].id;
          // console.log("gridA, Id selezionato:");
          console.log(this.docSpettacoloActiveId);
          for (const i in this.docSpettacoloFullData) {
            if (
              this.docSpettacoloFullData[i].id === this.docSpettacoloActiveId
            ) {
              // console.log("id dell'elenco trovato:")
              // console.log('SPETTACOLO CORRENTE')
              // console.log(this.docSpettacoloFullData[i])
              this.docSpettacoloActiveData = {
                ...this.docSpettacoloFullData[i],
              };
              found = true;
              break;
            }
          }
          console.log("DOC ALL SPETTACOLO CORRENTE");
          console.log(this.docSpettacoloActiveData);
          console.log(this.docSpettacoloActiveId);
          if (found) {
            //console.log('Edit persona fisica')
            this.$refs.dialogD.show(true);
            // Smisto in base a tipospettacolo
            // persona fisica
          } else {
            console.log("Elemento non trovato");
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "delete") {
        console.log("Premuto pulsante cancella documento allegato da gridB");
        try {
          const selectedRow = this.$refs.gridB.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;

          console.log("elemento da cancellare");
          console.log(deletedElementId);
          const deleteUrl = `${apiDocSpettacoloUrl}/${deletedElementId}`;
          this.$refs.gridB.ej2Instances.deleteRecord();

          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
            console.log(res.data);
          });
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "download") {
        try {
          const selectedRow = this.$refs.gridB.getSelectedRecords();
          const downloadElementId = selectedRow[0].id;
          // ZZZZ
          useJwt
            .post("/demo/api/documento/download", { id: downloadElementId })
            .then((res) => {
              console.log("gridB download get response");
              console.log(res.status);
              console.log(res.data);
            });
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },
    gridBactionBegin(e) {
      if (!this.gridBFlag) {
        // Add and edit operations
        if (e.requestType === "save") {
          const editedData = e.data;
          console.log(editedData);
          // The default edit operation is cancelled
          e.cancel = true;
          const editUrl = `${apiSpettacoliUrl}/${editedData.id}`;
          useJwt.patch(editUrl, editedData).then((res) => {
            console.log(res);
            if (res.status === 200) {
              // se tutto OK
              // Flag is enabled to skip this execution when grid ends add/edit
              this.gridBFlag = true;
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridB.endEdit();
            } else {
              this.makeToast(
        "primary",
        "Attenzione",
        "Salvataggio spettacolo non riuscito"
              );
            }
          });
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridBactionComplete(e) {
      if (e.requestType === "save") {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridBFlag = false;
      }
    },
    // per gridC
    // per gridC -> lista file allegati a documento
    gridCClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        // se documentospettacolo non e' ancora stato salvato, fallo ora per poter poi gestire upload
        if (this.docSpettacoloActiveId === 0) {
          // documentospettacolo da salvare
          console.log("NOTA: documentospettacolo da salvare");

          this.docSpettacoloActiveData.soggetto = this.spettacoliActiveId; // associo ID spettacolo corrente

          console.log("voglio salvare queste info");
          console.log(this.docSpettacoloActiveData);
          console.log(
            `id spettacolo corrente (a cui associare il documento) ${this.spettacoliActiveId}`
          );

          useJwt
            .post(apiDocSpettacoloUrl, this.docSpettacoloActiveData)
            .then((res) => {
              console.log(res.status);
              console.log(res.data);
              this.docSpettacoloActiveId = res.data.id;
              this.docSpettacoloActiveData.id = res.data.id;
              this.docSpettacoloFullData.push(res.data);
              // refresh grid
              this.docSpettacoloFullData = [...this.docSpettacoloFullData];
            });
        }
        //console.log(this.fileDocumentoActiveData)
        console.log("apro dialogI");

        this.$refs.dialogI.show();
      } else if (args.item.id === "edit") {
        // mostrare diverso dialog per visualizzazione documento
        console.log(
      "Premuto pulsante modifica documentospettacolo allegato da gridC"
        );
        try {
          const selectedRow = this.$refs.gridC.getSelectedRecords();
          let found = false;
          this.fileDocumentoActiveId = selectedRow[0].id;
          // console.log("gridA, Id selezionato:");
          console.log(this.fileDocumentoActiveId);
          for (const i in this.fileDocumentoFullData) {
            if (
              this.fileDocumentoFullData[i].id === this.fileDocumentoActiveId
            ) {
              // console.log("id dell'elenco trovato:")
              // console.log('FILE DOCUMENTO CORRENTE')
          // console.log(this.fileDocumentoFullData[i])
              this.fileDocumentoActiveData = {
                ...this.fileDocumentoFullData[i],
              };
              found = true;
              break;
            }
          }
          console.log("FILE DOCUMENTO SPETTACOLO CORRENTE");
          console.log(this.fileDocumentoActiveData);
          if (found) {
            console.log("Edit fileDocumento allegato");
            this.$refs.dialogJ.show();
          } else {
            console.log("Elemento non trovato");
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "delete") {
        // cancellare fileDocumento selezionato
        try {
          console.log("Premuto pulsante elimina spettacolo da gridC");
          const selectedRow = this.$refs.gridC.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;

          const deleteUrl = `${apiFileDocumentoUrl}/${deletedElementId}`;
          this.$refs.gridC.ej2Instances.deleteRecord();

          useJwt.delete(deleteUrl).then(() => {
            console.log("Eliminazione avvenuta con successo");
            // console.log(res.data)
            this.makeToast(
              "primary",
              "Cancellazione",
              "file allegato cancellato con successo"
            );
          });
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "download") {
        const selectedRow = this.$refs.gridC.getSelectedRecords();
        const downloadElementUrl = selectedRow[0].fileDocumento;
        // far partire download del file ZZZ
        console.log(downloadElementUrl);
        const nomeFile = downloadElementUrl
          .split("\\")
          .pop()
          .split("/")
          .pop()
          .split("?")[0];
        this.makeToast("info", "Azione", `Apri il file ${nomeFile}`);
        // remove URL prefix and suffix from AWS filename
        console.log(`Nome file ${nomeFile}`);
        this.downloadFile(downloadElementUrl, nomeFile);
      }
    },
    gridCactionBegin(e) {},
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridCactionComplete(e) {},
    // per gridD (tmp)
    gridDClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        console.log("Nuova Recita");
        this.dialogE.header = "Nuova Recita";
        this.reciteSpettacoloDefaultData = {
          id: 0,
          spettacolo: this.spettacoliActiveData.id,
          data: null,
          orario: null,
          luogo: "Teatro Coccia",
          tipologia: null,
          turno: null,
          idRecitaSITickets: null,
          codiceStruttura: null,
          capienza: null,
          vigiliFuoco: null,
          siae: null,
          rassegna: null,
          IVAOmaggi: null,
          stato: null,
          note: null,
          durataPresuntaVVF: null,
        };
        this.reciteSpettacoloActiveData = this.reciteSpettacoloDefaultData;
        console.log("Premuto pulsante creazione nuova recita da gridD");
        this.reciteSpettacoloActiveId = 0;
        this.$refs.dialogE.show(true);
      }
      // pulsante EDIT
      else if (args.item.id === "edit") {
        console.log("Premuto pulsante modifica recita da gridD");
        try {
          const selectedRow = this.$refs.gridD.getSelectedRecords();
          this.reciteSpettacoloActiveId = selectedRow[0].id;
          // console.log("gridA, Id selezionato:");
          console.log(this.reciteSpettacoloActiveId);
          const i = this.reciteSpettacoloFullData.findIndex(
            (x) => x.id === this.reciteSpettacoloActiveId
          );
          if (i >= 0) {
            this.reciteSpettacoloActiveData = {
              ...this.reciteSpettacoloFullData[i],
            };
            // fix nome immagineLocandina AWS (TMP)
            // this.reciteSpettacoloActiveData.immagineLocandina = "https://drf-coccia.s3.eu-south-1.amazonaws.com/drf-coccia/tmpImage_HB7y2N2.jpg" // aggiunto Simo 19/01
            console.log("RECITA CORRENTE");
            console.log(this.reciteSpettacoloActiveData);
            console.log(this.reciteSpettacoloActiveId);
            // spettacolo generico
            console.log("Edit recita");
            this.dialogE.header = "Modifica Recita";
            this.$refs.dialogE.show(true);
          } else {
            console.log("Elemento non trovato");
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "delete") {
        // Pulsante DELETE
        try {
          console.log("Premuto pulsante elimina recita da gridD");
          const selectedRow = this.$refs.gridD.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;
          const deleteUrl = `${apiRecitaUrl}/${deletedElementId}`;

          this.$refs.gridD.ej2Instances.deleteRecord();

          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
            console.log(res.data);
          });
        } catch (err) {
          // da sistemare..............
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },
    gridDactionBegin(args) {},
    gridDactionComplete(args) {},
    // per click tabs
    tabClicked(args) {
      switch (args) {
        case "dialogA1Tab01":
          console.log("Sei nel primo tab del dialogA1");
          break;
        case "dialogA1Tab02":
          console.log("Sei nel secondo tab del dialogA1");
          //this.salvaSpettacolo()
          break;
        default:
          console.log(args);
      }
    },

    // per salvare spettacolo al momento del passaggio ad un altro tab (o in caso di pressione del tasto OK)
    salvaSpettacolo() {
      if (this.spettacoliActiveId !== 0) {
        if (this.hasChanged) {
          // salva su remoto solo se form cambiata
          // se info modificate
          console.log("-- salvaSpettacolo salva edit-- ");
          //this.spettacoliActiveData.immagineLocandina="aaaa" // aggiunta simon 19/01
          const editUrl = `${apiSpettacoliUrl}/${this.spettacoliActiveId}`;
          useJwt.patch(editUrl, this.spettacoliActiveData).then((res) => {
            console.log(this.spettacoliActiveData); // aggiunta simo 19/01
            console.log(res.status);
            console.log(res.data);
          });
        } else {
          console.log("nessuna modifica");
        }
      } else {
        // salva nuovo spettacolo
        console.log("-- salvaSpettacolo salva nuovo-- ");
        console.log(this.spettacoliActiveData);

        useJwt.post(apiSpettacoliUrl, this.spettacoliActiveData).then((res) => {
          console.log(res.status);
          console.log(res.data);
          this.spettacoliActiveId = res.data.id;
          this.spettacoliActiveData.id = res.data.id;
        });
      }
    },
    // per click tabs
    tabClicked(args) {
      switch (args) {
        case "dialogATab01":
          console.log("Sei nel primo tab del dialogA");
          break;
        case "dialogATab02":
          console.log("Sei nel secondo tab del dialogA");
          this.salvaSpettacolo();
          break;
        default:
          console.log(args);
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    // per file upload: ?? Serve differenziarli nei vari elementi fileUpload??
    addJWTHeaders(args) {
      const token = useJwt.getToken();

      useJwt.check(); // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader("Authorization", `Bearer ${token}`);
    },
    onFileUpload(args) {
      const token = useJwt.getToken();

      useJwt.check(); // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader("Authorization", `Bearer ${token}`);
    },
    afterUpload(args) {
      console.log(args);
      if (args.name === "success") {
        console.log("tutto a posto");
        // TODO: Inserire notifica successo
      }
    },
    noop() {
      console.log("premuto enter");
    },
  },
  computed: {
    hasChanged() {
      // console.log(this.spettacoliActiveData)
      // console.log(this.spettacoliSavedData)
      return Object.keys(this.spettacoliActiveData).some(
        (field) =>
          this.spettacoliActiveData[field] !== this.spettacoliSavedData[field]
      );
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active{ 
  background-color: #e5cbdd; 
}
</style>
